import React, { useState, useEffect, useCallback } from 'react';
import { MenuItem, createTheme, TextField, AppBar, Checkbox, Button, Tooltip, Toolbar, Modal, ListItemIcon, Menu, ListItemText, Grid, Box, Dialog, DialogContent, TableContainer, Table, TableCell, TableBody, TableHead, TableRow, useTheme, IconButton, Divider, DialogTitle, alpha, FormControlLabel, Switch } from '@mui/material';
import { GridRowModes, GridToolbarContainer, GridRowEditStopReasons, } from '@mui/x-data-grid';
import dayjs from 'dayjs';

import { debounce } from 'lodash';
import ReactDOM from "react-dom/client";

// icons

import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import CloseIcon from "@mui/icons-material/Close";

import useAutocompleteData from '../../../pages/commonapicall/useAutocompleteData';

import { API_ENDPOINTS } from '../../../config/api/apiCall';
import GlobalConfig from '../../../components/GlobalConfig';
import { tokens } from "../../../theme/theme";
import InvoiceReport from './InvoiceReport';
import PackingListReport from './PackingListReport';
import InvoiceActionMenu from './InvoiceActionMenu';
import InvoiceEntryTemplate from './InvoiceEntryTemplate';
import { callApi } from '../../../utils/apiClient';
import CustomTableContainer from '../../../components/table/CustomTableContainer';
import DateRangePicker from '../../../components/DateRangePicker';
import { useMasterData } from '../../../hooks/useMasterData';
import useDefaultParameterConfigById from '../../../hooks/useDefaultParameterConfigById';

// import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CustomSnackbar from '../../../components/CustomSnackbar';
import * as XLSX from "xlsx-js-style"; // <-- important: use xlsx-js-style for styling support
import DateRangePickerForInvoice from '../../../components/DateRangePickerForInvoice';
import TableFilterRow from '../../../components/table/TableFilterRow';
import CustomPagination from '../../../components/table/CustomPagination';
import ResponsiveBox from '../../../components/form/ResponsiveScrollBox';



// json convertion support files

function formatDateTo_ddMMyyyy(input) {
    if (!input) return "";
    const d = input instanceof Date ? input : new Date(input);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`; // matches tmpInvoiceDate_f in VB
}

function toDecimal(v, defaultVal = 0) {
    if (v === null || v === undefined || v === "") return defaultVal;
    const n = Number(v);
    return isNaN(n) ? defaultVal : n;
}

function roundTo(value, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
}

const CreateNewInvoice = ({ handleBackWinderMachineEntry, editRow }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [FromCODate, setFromCODate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToCODate, setToCODate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [OrderDate, setOrderDate] = useState(dayjs());
    const [minInvoiceDate, set_minInvoiceDate] = useState(dayjs());
    const [ScheduleDate, setScheduleDate] = useState(dayjs());
    const [Remarks, SetRemarks] = useState('');

    const [truckNumber, setTruckNumber] = useState('');
    const [lrNumber, setLRNumber] = useState('');
    const [lrDate, setLRDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [distance, setDistance] = useState(0);

    const [viewCreateDespatchPlan, setViewCreateDespatchPlan] = useState(false);
    const [viewCreateInvoiceEntry, setViewCreateInvoiceEntry] = useState(false);
    const [isVisible_DespatchItem, setisVisible_DespatchItem] = useState(false);
    const [viewCommonButton, setViewCommonButton] = useState(false);
    const [viewCancelDetail, setViewCancelDetail] = useState(false);
    const [isVisiblebtnCreateDespatchPlan, setisVisiblebtnCreateDespatchPlan] = useState(true);
    const [isVisiblebtnAddSelectedCO, setisVisiblebtnAddSelectedCO] = useState(false);

    const [fromModule, setFormModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [headerDespatchplan, SetheaderDespatchplan] = useState('New Invoice Order');
    const [btnApprove, setbtnApprove] = useState(false);
    const [btnSaveUpdate, setbtnSaveUpdateOrdershow] = useState(false);
    const [btnAmendment, setbtnAmendmentshow] = useState(false);
    const [btnPrint, setbtnPrint] = useState(false);
    const [btnCancel, setbtnCancel] = useState(false);
    const [btnGenerateInvoice, set_btnGenerateInvoice] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');
    const [btnSaveText, setBtnSaveText] = useState('Save');
    const [btnSaveTooltip, setBtnSaveTooltip] = useState('Save Invoice');
    const [openAlert, setOpenAlert] = useState(false);

    const [loading, setLoading] = React.useState(false);
    const [rows, setTableData] = useState([]);

    const [rowsConfirmedOrders, setrowsConfirmedOrders] = useState([]);
    const [filteredData_ConfirmedOrders, setFilteredData_ConfirmedOrders] = useState([]);
    const [searchText_ConfirmedOrders, setSearchText_ConfirmedOrders] = useState('');
    const [selectCOOrders, setselectCOOrders] = useState([]);
    const [Reason, SetReason] = useState('');
    const [cancelDate, setSelectedDate] = React.useState();
    const [ReasonError, setReasonError] = useState("");
    const [DateError, setDateError] = useState("");
    const [SAmendmentReason, SetSAmendmentReason] = useState('');
    const [visibleAmendmentReason, setvisibleAmendmentReason] = useState(false);
    const [amendReasonError, setamendReasonError] = useState("");

    const [SInvoiceNo, SetSInvoiceNo] = useState('');
    const [DespatchNoAF, SetDespatchNoAF] = useState(false);

    const [iDeliveryOrderId, setiDeliveryOrderId] = useState(0);
    const [iInvoiceOrderId, setiInvoiceOrderId] = useState(0);
    const [iIndentID, setiIndentID] = useState(0);
    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [iDespatchPlanID, setiDespatchPlanID] = useState(0);
    const [SRefNo, SetSRefNo] = useState('');
    const [selectedTransporter, setSelectedTransporter] = useState('');
    const [STransporter, setSTransporter] = useState(0);
    const [transporterError, settransporterError] = useState("");
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const [selectedPricelist, setSelectedPricelist] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [customerAddress, setcustomerAddress] = useState("");
    const [supplierAddress, setsupplierAddress] = useState("");
    const [billToCustomerError, setBillToCustomerError] = useState("");
    const [shipToCustomerError, setshipToCustomerError] = useState("");
    const [priceListError, setpriceListError] = useState("");

    const [Pricelistid, setPriceList] = useState('');
    const [SShipToCustomer, setSupplier] = useState(0);
    const [SBillToCustomer, setBillToCustomer] = useState(0);
    const [selectedShipmentMode, setSelectedShipmentMode] = useState('');
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState('');
    const [selectedCreditTerm, setSelectedCreditTerm] = useState('');
    const [selectedCreditTermRule, setSelectedCreditTermRule] = useState('');
    const [Id_ShipmentMode, setId_ShipmentMode] = useState(null);
    const [Id_PaymentTerm, setId_PaymentTerm] = useState(null);
    const [Id_CreditTerm, setId_CreditTerm] = useState(null);
    const [Id_CreditTermRule, setId_CreditTermRule] = useState(null);
    const [totalSIConfirmedQty, set_totalSIConfirmedQty] = useState(0);
    const [totalGrossAmount, set_totalGrossAmount] = useState(0);
    const [totaldiscountAmount, settotaldiscountAmount] = useState(0);
    const [totalAmount, settotalAmount] = useState(0);
    const [IParentInvoiceOrder_ID, set_IParentInvoiceOrder_ID] = useState(0);
    const [iDespatchOrderIdList, set_iDespatchOrderIdList] = useState(0);
    const [iShippedOrderIdList, set_iShippedOrderIdList] = useState(0);
    const [iInvoiceOrderIdList, set_iInvoiceOrderIdList] = useState(0);
    const [iConfirmationIdList, set_iConfirmationIdList] = useState(0);
    const [DocumentSeries, SeDocumentSeries] = useState(12);
    const [bOrderInvoiced, set_bOrderInvoiced] = useState(false);
    const masterGroup = '';
    const [selectedOrders, setSelectedOrders] = useState([]);
    const isSelected = (orderId) => selectedOrders.indexOf(orderId) !== -1;
    const [gridAutoRows, setGridAutoRows] = useState(calculateGridAutoRows());
    const [open, setOpen] = useState(false);
    const [sameParty, setSameParty] = useState(false);


    let [FinancierYear, setFinancierYear] = useState(1);
    let [LOGIN_USER, setLOGIN_USER] = useState('');

    const [CompanyID, setCompanyID] = useState('');
    const [cancelReasonFoucs, SetcancelReasonFoucs] = useState(false);
    const [amendmentReasonFoucs, SetamendmentReasonFoucs] = useState(false);

    const [showInvoiceReport, setShowInvoiceReport] = useState(false);
    const [taxMode, setTaxMode] = useState(0);
    const [PackingList, setPackingList] = useState([]);
    const [InvoiceList, setInvoiceList] = useState([]);
    const [viewReport, setViewReport] = useState(false);

    const [manualTCSRate, setManualTCSRate] = useState(0);
    const [manualFreightRate, setManualFreightRate] = useState(0);
    const [manualServiceChargeRate, setManualServiceChargeRate] = useState(0);
    const [manualCessRate, setManualCessRate] = useState(0);
    const [manualInsuranceRate, setManualInsuranceRate] = useState(0);

    const [manualTCSRateEdit, setManualTCSRateEdit] = useState(0);

    const [searchType, setSearchType] = useState("DO No");
    const [searchValue, setSearchValue] = useState("");

    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);


    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const [isEdit, setIsEdit] = useState(false);
    const [mastersLoaded, setMastersLoaded] = useState(false); // ✅ track first call completion


    // hooks 
    const {
        masterDataLoading,
        dataTransporter,
        dataSupplier,
        dataManufacturer,
        dataPricelist,
        dataCustomer,
        dataShipmentmode,
        dataPaymentterm,
        dataCreditterm,
        dataCredittermRule,
        reload,
    } = useMasterData({ FinancierYear, masterGroup, CompanyID, API_ENDPOINTS, showError, mastersLoaded, setMastersLoaded });
    const { defaultParameterConfig, setDefaultParameterConfig, isDataLoaded, setIsDataLoaded, getParemeterDetail } = useDefaultParameterConfigById(14);

    useEffect(() => {
        if (!isDataLoaded) {
            getParemeterDetail(14);
        }
    }, [isDataLoaded])


    const handleShowReport = () => {
        console.log("Button clicked — opening report");
    };

    const handleCloseReport = () => {
        console.log("Closing report");
        setShowInvoiceReport(false);
    };


    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        if (retrievedUserID) {
            setCompanyID(localStorage.getItem('companyid'));
        }
    }, []); // Empty dependency array to run only once on mount

    const commonParams = {
        FinancierYear,
        masterGroup,
    };

    const handleSelectShipmentMode = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedShipmentMode(newValue);
            setId_ShipmentMode(newValue.CodeId);
        }
    };

    const handleSelectPaymentTerm = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedPaymentTerm(newValue);
            setId_PaymentTerm(newValue.CodeId);
        }
    };

    const handleSelectCreditTerm = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCreditTerm(newValue);
            setId_CreditTerm(newValue.CodeId);
        }
    };

    const handleSelectCreditTermRule = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCreditTermRule(newValue);
            setId_CreditTermRule(newValue.CodeId);
        }
    };

    const handleSelectPoNo = (e) => {
        SetSRefNo(e.target.value);
    }

    const handleSelectSupplier = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedSupplier(newValue);
            setSupplier(newValue.CodeId);

            const SPartyID = newValue.CodeId;
            const SPartyAddressType = "Shipping";

            fetchAddressData(SPartyID, SPartyAddressType)
                .then(data => {
                    setsupplierAddress("Address: " + getAddressString(data));
                })
                .catch(error => {
                    setAlertMessage('Unable to select supplier properly.!');
                    setalertsevierity('error');
                    showSnackbar();
                });
        }
    };

    const handleSelectCustomer = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCustomer(newValue);
            setBillToCustomer(newValue.CodeId);

            if (dataSupplier.length > 0) {
                const codeIdValue = newValue.CodeId;
                const stringCodeIdValue = String(codeIdValue);
                const filteredData = dataSupplier.filter((item) => item.CodeId === stringCodeIdValue);

                if (filteredData.length > 0) {
                    setSelectedSupplier(filteredData[0]);
                    setSupplier(newValue.CodeId);
                }
            }

            const SPartyID = newValue.CodeId;
            const SPartyAddressType = "Billing";

            fetchAddressData(SPartyID, SPartyAddressType)
                .then(data => {
                    setcustomerAddress("Address: " + getAddressString(data));
                    setsupplierAddress("Address: " + getAddressString(data));
                })
                .catch(error => {
                    setAlertMessage('Unable to get the address properly.!');
                    setalertsevierity('error');
                    showSnackbar();
                });
        }
    };

    const fetchAddressData = async (SPartyID, SPartyAddressType) => {
        const cls_Party = { SPartyID, SPartyAddressType };

        const response = await fetch(API_ENDPOINTS.getPartyAddress, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cls_Party)
        });
        if (!response.ok) {
            throw new Error('Unable to get the address..!');
        }
        return await response.json();
    };

    const getAddressString = (data) => {
        return `Address: ${data[0].LabelValueColumn2}, ${data[1].LabelValueColumn2} | State: ${data[2].LabelNameColumn2} | City: ${data[2].LabelValueColumn2} | Postal Code: ${data[3].LabelValue}`;
    };

    const handleSelectTransporter = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedTransporter(newValue);
            setSTransporter(newValue.CodeId);
        }
    };

    const handleSelectPricelist = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedPricelist(newValue);
            setPriceList(newValue.CodeId);
            setOpenAlert(false);
        }
    };

    const useAutocompleteDataByMasterGroup = (masterGroup) => {
        const data = useAutocompleteData(
            API_ENDPOINTS.GET_MASTER_LIST,
            {
                ...commonParams,
                masterGroup: masterGroup,
            }
        );
        return data;
    };



    const loadMasterData = useCallback(async (endpoint, params, setState, notFoundMessage) => {
        try {
            const result = await callApi(
                endpoint,
                'POST',
                { 'Content-Type': 'application/json' },
                params
            );

            if (result && result.length > 0) {
                const updatedData =
                    Array.isArray(result) && !result.includes('')
                        ? [''].concat(result)
                        : result;

                setState(updatedData);
                return updatedData; // return so Promise.all can use it
            } else {
                alert(notFoundMessage);
                return null;
            }
        } catch (error) {
            alert(error.message);
            return null;
        }
    }, []);




    // Call 2: only runs after mastersLoaded = true
    useEffect(() => {
        if (mastersLoaded && editRow.length !== 0 && !isEdit) {
            const fetchData = async () => {
                setIsEdit(true);
                await handleOnCellClick(editRow);
                setIsEdit(false);
            };
            fetchData();
        }
        else if (mastersLoaded && editRow.length === 0 && !isEdit) {
            handleCreateDispatchPlans();
        }
    }, [mastersLoaded, editRow, isEdit]);


    const LoadInoviceOrderList = () => {
        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        } else {
            setLoading(true); // Set loading state to true before fetching data

            const formattedFromDate = dayjs(FromDate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToDate).format('YYYY-MMM-DD');

            const requestBody = {
                SearchType: '',
                SearchString: '',
                SInvoiceNo: '',
                InvoiceDateFrom: formattedFromDate,
                InvoiceDateTo: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            fetch(API_ENDPOINTS.LoadInoviceOrderList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(async response => {
                    if (!response.ok) {
                        // Log response details for debugging
                        console.error('Response status:', response.status, response.statusText);
                        const text = await response.text();
                        throw new Error(text || 'Unable to load invoice order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const ShippedOrderDate = new Date(row.ShippedOrderDate).toLocaleDateString();
                        const InvoiceDate = new Date(row.InvoiceDate).toLocaleDateString();
                        return { ...row, id: index + 1, ShippedOrderDate, InvoiceDate };
                    });
                    setTableData(formattedData);
                })
                .catch(error => {
                    showError(`Error: ${error.message}`, 'error');
                    console.error('Error details:', error); // Log error for debugging
                })
                .finally(() => {
                    setLoading(false); // Set loading state to false after fetching data
                });

        }
    };

    const debouncedLoadInoviceOrderList = debounce(LoadInoviceOrderList, 500);

    const filterData_ConfirmedOrders = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText_ConfirmedOrders.toLowerCase())
            )
        );
        setFilteredData_ConfirmedOrders(filtered);
    };

    const LoadConfirmedOrderList = () => {
        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        } else {

            const formattedFromDate = dayjs(FromCODate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToCODate).format('YYYY-MMM-DD');

            const requestBody = {
                SearchType: searchType,
                SearchString: searchValue,
                SInvoiceNo: '',
                InvoiceDateFrom: formattedFromDate,
                InvoiceDateTo: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load confirmation order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {

                        return { ...row, id: index + 1, };
                    });

                    setrowsConfirmedOrders(formattedData);
                })
                .catch(error => {
                    showError('Unable to load confirmation order details', 'warning');
                });
        }
    };

    const onSearchClick = async () => {
        // await loadInvoiceOrderList(fromData, toDate, searchType, searchValue);
    };


    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        debouncedLoadInoviceOrderList();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        debouncedLoadInoviceOrderList();
    };

    const handleFromCODate = (date) => {
        setFromCODate(dayjs(date));
        // LoadConfirmedOrderList();
    };

    const handleToCODate = (date) => {
        setToCODate(dayjs(date));
        //LoadConfirmedOrderList();
    };
    const handlerOrderDate = (date) => {
        setOrderDate(dayjs(date));
    };
    const handleScheduleDate = (date) => {
        setScheduleDate(dayjs(date));
    };

    const handleCreateDispatchPlans = () => {
        setViewCreateDespatchPlan(true);

        setViewCreateInvoiceEntry(false);
        setViewCommonButton(false);
        setisVisible_DespatchItem(false);
        setFormModule('Invoice Order List')

        setisVisiblebtnCreateDespatchPlan(true);
        setisVisiblebtnAddSelectedCO(false);
        setViewCancelDetail(false);

        SetReason('');
        SetSAmendmentReason('');
    };



    const LoadConfirmationOrderDetailForDespatchOrder = (requestBody) => {
        fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice_for_CreateInvoice, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to create the invoice');
                }
                return response.json();
            })
            .then(data => {
                SetSInvoiceNo(data.SInvoiceNo);
                set_iInvoiceOrderIdList(data.InvoiceOrderIdList);
                set_iConfirmationIdList(data.ConfirmationOrderIdList);
                if (data.SParentInvoiceOrder_ID === 0) {
                    data.SOrderStatus = "[New]"
                }
                set_IParentInvoiceOrder_ID(data.SParentInvoiceOrder_ID);
                if (data.SInvoiceNo != '') {
                    set_bOrderInvoiced(true);
                }

                if (data.SInvoiceDate != null) {
                    setOrderDate(data.SInvoiceDate);
                }

                set_minInvoiceDate(data.SShipmentPlanDate);
                setTruckNumber(data.TruckNumber);
                setLRNumber(data.SLRNo);
                if (data.SLRDate != null) {
                    setLRDate(data.SLRDate);
                }
                setDistance(data.Distanceinkm);
                SetSRefNo(data.SRefNo);

                handleFilterAndSetSelection(dataCustomer, setSelectedCustomer, 'SBillToCustomer', data, setBillToCustomer);
                handleFilterAndSetSelection(dataSupplier, setSelectedSupplier, 'SShipToCustomer', data, setSupplier);
                handleFilterAndSetSelection(dataPricelist, setSelectedPricelist, 'SPriceList', data, setPriceList);
                handleFilterAndSetSelection(dataTransporter, setSelectedTransporter, 'STransporter', data, setSTransporter);

                handleFilterAndSetSelection(dataShipmentmode, setSelectedShipmentMode, 'SShipmentMode', data, setId_ShipmentMode);
                handleFilterAndSetSelection(dataPaymentterm, setSelectedPaymentTerm, 'SPaymentTerm', data, setId_PaymentTerm);
                handleFilterAndSetSelection(dataCreditterm, setSelectedCreditTerm, 'SCreditTerm', data, setId_CreditTerm);
                handleFilterAndSetSelection(dataCredittermRule, setSelectedCreditTermRule, 'SCreditLimitRule', data, setId_CreditTermRule);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }

                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);
                RefreshStatus(data.SOrderStatus);
                setFormModule('Invoice Ordes');
                setbtnCancel(false);
                setbtnApprove(false);

                // headerdata
                setHeaderData(data);
                setplannedQtyData(fdata);

                handleOrderItemCalculation(data, fdata)
            })
            .catch(error => {
                showError('Unable to create the invoice', 'error');
            });
    }

    function validateForm() {
        let isFormDataValid = true;

        if (rowsConfirmedOrders.length === 0) {
            showError("Please select the order items to include in the Invoice Plan", "warning");
            return false;
        }

        const selectedRows = rowsConfirmedOrders.filter(row => row.SelectItem);
        const distinctBillToCustomers = [...new Set(selectedRows.map(row => row.BillToCustomer))];
        const distinctShipToCustomers = [...new Set(selectedRows.map(row => row.ShipToCustomer))];

        if (selectedRows.length > 1 && (distinctBillToCustomers.length > 1 || distinctShipToCustomers.length > 1)) {
            showError("Bill To and Ship To Customers should be same", "warning");
            isFormDataValid = false;
        }
        return isFormDataValid;
    }

    const handleShowDispatchPlansEntry = () => {
        if (validateForm() !== false) {
            if (sameParty) {
                const confirmed = window.confirm(
                    "Different party orders are chosen and will be converted to single party during invoice creation.\nAre you sure to continue?"
                );

                if (!confirmed) {
                    return; // same as Exit Sub
                }
            }

            let selectedDPIds = [];
            let selectedDOIDs = [];
            let selectedIOIds = [];
            let selectedCOIdsNew = [];

            selectCOOrders.forEach((oItemRow) => {
                if (!selectedDPIds.includes(parseInt(oItemRow.DespatchPlanId))) {
                    selectedDPIds.push(parseInt(oItemRow.DespatchPlanId));
                }
                selectedDOIDs.push(parseInt(oItemRow.DeliveryOrderId));
                selectedIOIds.push(parseInt(oItemRow.InvoiceOrderId));
                selectedCOIdsNew.push(parseInt(oItemRow.ConfirmationOrderId));
            });

            setiConfirmationID(selectedCOIdsNew);
            setiDespatchPlanID(selectedDPIds);
            setiDeliveryOrderId(selectedDOIDs);
            setiInvoiceOrderId(selectedIOIds);

            if (selectedDOIDs.length === 0) {
                showError('Please select the order items to include in the despatch plan', 'info');
                return;
            }
            const sListDPIds = selectedDPIds.join(',');
            const sListDOIDs = selectedDOIDs.join(',');
            const sListIOIds = selectedIOIds.join(',');
            const sListCOIDs = selectedCOIdsNew.join(',');

            set_iDespatchOrderIdList(sListDPIds);
            set_iShippedOrderIdList(sListDOIDs);
            set_iInvoiceOrderIdList(sListIOIds);
            set_iConfirmationIdList(sListCOIDs);

            if (sListIOIds != "") {
                const requestBody = {
                    DespatchOrderIdList: sListDPIds,
                    ShippedOrderIdList: sListDOIDs,
                    InvoiceOrderIdList: sListIOIds,
                    ConfirmationOrderIdList: sListCOIDs,
                    BoolConvertToSameCustomer: sameParty,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: localStorage.getItem('companyid'),
                    },
                };
                LoadConfirmationOrderDetailForDespatchOrder(requestBody);
            }
        }

    };



    const openReportWindow = (ReportComponent, title, data) => {
        const reportWindow = window.open("", title, "width=1000,height=800");
        reportWindow.document.title = title;

        const container = reportWindow.document.createElement("div");
        reportWindow.document.body.appendChild(container);

        const root = ReactDOM.createRoot(container);
        root.render(<ReportComponent data={data} />);
    };


    const [viewPackingList, setViewPackingList] = useState(false);
    const [viewInvoiceReport, setViewInvoiceReport] = useState(false);
    const [viewPackingListReportExport, setPackingListReportExport] = useState(false);


    const handleViewReport = async (printmode) => {

        //invoice load 
        try {

            if (printmode === 'invoice') {

                //openReportWindow(InvoiceReport, "Invoice")
                try {
                    if (!IParentInvoiceOrder_ID || IParentInvoiceOrder_ID === 0) {
                        showError('Invalid Parent Invoice Order ID!', 'warning');
                        return;
                    }

                    const requestBody = {
                        IParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: localStorage.getItem('companyid'),
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: localStorage.getItem('companyid'),
                        },
                    };

                    const response = await callApi(
                        API_ENDPOINTS.REPORT_INVOICE_ALL_COPIES,
                        'POST',
                        { 'Content-Type': 'application/json' },
                        requestBody
                    );

                    if (response[0].invoice_detail && response[0].invoice_detail.length > 0) {
                        if (response && response.length > 0) {
                            setInvoiceList(response);
                            setViewReport(true);
                            setViewInvoiceReport(true);
                            setInvoiceDetail(false);
                            setViewPackingList(false);
                        }

                    } else {
                        showError('No data found for the selected Invoice Order!', 'info');
                    }
                } catch (error) {
                    console.error('Error loading packing list:', error);
                    showError('Failed to generate packing list.', 'error');
                }


            }
            else if (printmode === 'packinglist') {
                try {
                    if (!IParentInvoiceOrder_ID || IParentInvoiceOrder_ID === 0) {
                        showError('Invalid Parent Invoice Order ID!', 'warning');
                        return;
                    }

                    const requestBody = {
                        IParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: localStorage.getItem('companyid'),
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: localStorage.getItem('companyid'),
                        },
                    };

                    const response = await callApi(
                        API_ENDPOINTS.REPORT_INVOICE_PACKINGLIST,
                        'POST',
                        { 'Content-Type': 'application/json' },
                        requestBody
                    );

                    if (response && response.length > 0) {
                        setPackingList(response);
                        setViewReport(true);
                        setViewPackingList(true);
                        setInvoiceDetail(false);

                    } else {
                        showError('No data found for the selected Invoice Order!', 'info');
                    }
                } catch (error) {
                    console.error('Error loading packing list:', error);
                    showError('Failed to generate packing list.', 'error');
                }


            }

            else if (printmode === 'packinglistexport') {
                //openReportWindow(PackingListExcelDownload, "Invoice")
                handleInvoiceExport();
            }

        } catch (error) {
            console.error('Error generating report:', error);
            // Handle error
        } finally {
            setLoading(false);
        }

    };


    const handleInvoiceExport = async () => {
        // try {
        //     // Fixed params
        //     const payload = {
        //         p_companyid: localStorage.getItem('companyid'),
        //         p_finyearid: FinancierYear,
        //         p_parentinvoiceorderid: IParentInvoiceOrder_ID,
        //     };

        //     // API call using your helper
        //     const endpoint = API_ENDPOINTS.DownloadPackingListExcelReport;
        //     const response = await callApi(
        //         endpoint,
        //         "POST",
        //         { "Content-Type": "application/json" },
        //         payload
        //     );

        //     if (!response || response.length === 0) {
        //         alert("No packing list data found!");
        //         return;
        //     }

        //     // i want set rename column name in response 
        //     // OrderNo as Order No
        //     // BundleRefNo as Bundle Ref. No
        //     // PO as PO
        //     // SLoc as SLoc
        //     // Batch as Batch
        //     // BundleNo as Bundle
        //     // ReamWt as Ream wt.
        //     // NoOfReams as No Of Reams.
        //     // GrWt as Gr Wt.
        //     // NetQty as Net Qty
        //     // UOM as UOM
        //     // VendorInvoiceNo as Vendor Invoice No

        //     //also set column background grey , font color black

        //     // Convert JSON to Excel
        //     const worksheet = XLSX.utils.json_to_sheet(response);
        //     const workbook = XLSX.utils.book_new();
        //     XLSX.utils.book_append_sheet(workbook, worksheet, "PackingList");

        //     // Export file
        //     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        //     const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
        //     saveAs(fileData, "PackingList.xlsx");
        // } catch (error) {
        //     console.error("Error fetching packing list:", error);
        //     alert("Failed to fetch packing list data!");
        // }


        try {
            const payload = {
                p_companyid: localStorage.getItem("companyid"),
                p_finyearid: FinancierYear,
                p_parentinvoiceorderid: IParentInvoiceOrder_ID,
            };

            const endpoint = API_ENDPOINTS.DownloadPackingListExcelReport;
            const response = await callApi(
                endpoint,
                "POST",
                { "Content-Type": "application/json" },
                payload
            );

            if (!response || response.length === 0) {
                alert("No packing list data found!");
                return;
            }

            // ✅ Rename columns
            const columnMap = {
                OrderNo: "Order No",
                BundleRefNo: "Bundle Ref. No",
                PO: "PO",
                ItemNo: "ItemNo",
                SLoc: "SLoc",
                Batch: "Batch",
                BundleNo: "Bundle",
                ReamWt: "Ream wt.",
                NoOfReams: "No Of Reams",
                GrWt: "Gr Wt.",
                NetQty: "Net Qty",
                UOM: "UOM",
                VendorInvoiceNo: "Vendor Invoice No",
            };

            const renamedData = response.map((item) => {
                const renamedItem = {};
                for (const key in item) {
                    renamedItem[columnMap[key] || key] = item[key];
                }
                return renamedItem;
            });

            // ✅ Get header names
            const headers = Object.keys(renamedData[0]);

            // ✅ Create empty worksheet first
            const worksheet = XLSX.utils.book_new();

            // ✅ Add only data rows (without headers)
            const dataRows = renamedData.map((obj) => headers.map((h) => obj[h]));
            const ws = XLSX.utils.aoa_to_sheet([]);

            // ✅ Add styled header row manually
            const headerRow = headers.map((h) => ({
                v: h,
                s: {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "D9D9D9" } }, // light grey
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                },
            }));

            XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: "A1" });

            // ✅ Add actual data starting from A2
            XLSX.utils.sheet_add_aoa(ws, dataRows, { origin: "A2" });

            // ✅ Auto column width
            const colWidths = headers.map((header) => {
                const maxLength = Math.max(
                    header.length,
                    ...renamedData.map((r) => (r[header] ? r[header].toString().length : 0))
                );
                return { wch: maxLength + 2 };
            });
            ws["!cols"] = colWidths;

            // ✅ Create workbook and export
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, ws, "PackingList");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            saveAs(blob, "PackingList.xlsx");

        } catch (error) {
            console.error("Error fetching packing list:", error);
            alert("Failed to fetch packing list data!");
        }

    }


    const handleBackTofromDespacthPlanEntry = () => {

        setViewCreateDespatchPlan(false);
        setViewCreateInvoiceEntry(false);
        setViewCommonButton(false);
        setisVisible_DespatchItem(false);

        if (fromModule === 'Invoice Order List') {
            handleBackWinderMachineEntry();
        }
        else if (fromModule === 'Invoice Ordes') {
            setViewCreateDespatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            setViewCreateInvoiceEntry(true);
            setViewCommonButton(true);
            SetfromSubModule('');
        }
    }

    const handleCancel = () => {
        setViewCancelDetail(true);
        handleCancelInvoice();
    }


    const handleBackTofromConnfrimOrderList = () => {
        setViewCreateDespatchPlan(false);
        setViewCreateInvoiceEntry(false);
        setViewCommonButton(false);
        setisVisible_DespatchItem(false);
        // setisVisible_DespatchPlan(true);
    }

    const handleOnCellClick = async (params, event) => {

        let selectedDPIds = [];
        let selectedDOIDs = [];
        let selectedIOIds = [];
        let selectedCOIdsNew = [];

        set_IParentInvoiceOrder_ID(params.InvoicePlanNo);
        setiIndentID(params.IndentId);
        setiConfirmationID(params.ConfirmationOrderId);
        setiDespatchPlanID(params.DespatchPlanId);
        setiDeliveryOrderId(params.DeliveryOrderId);
        setiInvoiceOrderId(params.InvoiceOrderId);

        // Iterate over rows and update local variables
        rows.forEach((oItemRow) => {
            if (parseInt(oItemRow.InvoicePlanNo) === params.InvoicePlanNo) {
                if (!selectedDPIds.includes(parseInt(oItemRow.DespatchPlanId))) {
                    selectedDPIds.push(parseInt(oItemRow.DespatchPlanId));
                }
                selectedDOIDs.push(parseInt(oItemRow.DeliveryOrderId));
                selectedIOIds.push(parseInt(oItemRow.InvoiceOrderId));
                selectedCOIdsNew.push(parseInt(oItemRow.ConfirmationOrderId));
            }
        });

        // Convert array of selected IDs to comma-separated strings
        const sListDPIds = selectedDPIds.join(',');
        const sListDOIDs = selectedDOIDs.join(',');
        const sListIOIds = selectedIOIds.join(',');
        const sListCOIDs = selectedCOIdsNew.join(',');

        set_iDespatchOrderIdList(sListDPIds);
        set_iShippedOrderIdList(sListDOIDs);
        set_iInvoiceOrderIdList(sListIOIds);
        set_iConfirmationIdList(sListCOIDs);

        if (params.InvoicePlanNo > 0) {

            LoadInvoiceOrderCombinedInvoicePrint(params)
        }


        setFormModule('Invoice Order List');
        setBtnSaveText('Update');
        setBtnSaveTooltip('Update Invoice');
        SetDespatchNoAF(true);
    };

    // Simplified and standards-aligned
    // const handleOnCellClick = async (params, _event) => {
    //     // Safe coercion and defaults
    //     const invoicePlanNo = Number(params?.InvoicePlanNo) || 0;

    //     // Preserve existing setter names (external references)
    //     set_IParentInvoiceOrder_ID(invoicePlanNo);
    //     setiIndentID(params?.IndentId ?? null);
    //     setiConfirmationID(params?.ConfirmationOrderId ?? null);
    //     setiDespatchPlanID(params?.DespatchPlanId ?? null);
    //     setiDeliveryOrderId(params?.DeliveryOrderId ?? null);
    //     setiInvoiceOrderId(params?.InvoiceOrderId ?? null);

    //     // Short-circuit if no rows
    //     if (!Array.isArray(rows) || rows.length === 0) {
    //         set_iDespatchOrderIdList('');
    //         set_iShippedOrderIdList('');
    //         set_iInvoiceOrderIdList('');
    //         set_iConfirmationIdList('');
    //         setFormModule('Invoice Order List');
    //         setBtnSaveText('Update');
    //         setBtnSaveTooltip('Update Invoice');
    //         SetDespatchNoAF(true);
    //         return;
    //     }

    //     // Collect IDs with correct types; Set for DP to avoid duplicates
    //     const dpIds = new Set();
    //     const doIds = [];
    //     const ioIds = [];
    //     const coIds = [];

    //     for (const r of rows) {
    //         const rPlan = Number(r?.InvoicePlanNo);
    //         if (Number.isFinite(rPlan) && rPlan === invoicePlanNo) {
    //             const dp = Number(r?.DespatchPlanId);
    //             const dord = Number(r?.DeliveryOrderId);
    //             const io = Number(r?.InvoiceOrderId);
    //             const co = Number(r?.ConfirmationOrderId);

    //             if (Number.isFinite(dp)) dpIds.add(dp);
    //             if (Number.isFinite(dord)) doIds.push(dord);
    //             if (Number.isFinite(io)) ioIds.push(io);
    //             if (Number.isFinite(co)) coIds.push(co);
    //         }
    //     }

    //     // Commit as comma-separated lists
    //     set_iDespatchOrderIdList([...dpIds].join(','));
    //     set_iShippedOrderIdList(doIds.join(','));
    //     set_iInvoiceOrderIdList(ioIds.join(','));
    //     set_iConfirmationIdList(coIds.join(','));

    //     // Execute follow-up action if valid
    //     if (invoicePlanNo > 0) {
    //         await LoadInvoiceOrderCombinedInvoicePrint(params);
    //     }

    //     // UI state updates
    //     setFormModule('Invoice Order List');
    //     setBtnSaveText('Update');
    //     setBtnSaveTooltip('Update Invoice');
    //     SetDespatchNoAF(true);
    // };


    const handleFilterAndSetSelection = (dataArray, setValueFunction, codeIdField, data, setCodeId) => {

        if (dataArray.length > 0) {
            const codeIdValue = data?.[codeIdField];

            if (codeIdValue !== undefined && codeIdValue !== null) {
                const stringCodeIdValue = String(codeIdValue).trim();

                const filteredData = dataArray.filter(
                    (item) => String(item.CodeId).trim() === stringCodeIdValue
                );

                if (filteredData.length > 0) {
                    setValueFunction(filteredData[0]);
                    setCodeId(codeIdValue);
                } else {
                    // console.warn("No matching item found", codeIdValue, dataArray);
                }
            } else {
                // console.warn("codeIdValue is undefined or null", data, codeIdField);
            }

            if (codeIdField === 'SBillToCustomer') {

                const SPartyID = codeIdValue;
                const SPartyAddressType = "Billing";

                fetchAddressData(SPartyID, SPartyAddressType)
                    .then(data => {
                        setcustomerAddress("Address: " + getAddressString(data));
                        setsupplierAddress("Address: " + getAddressString(data));

                        if (!localStorage.getItem('companyState')) {
                            showError('Unable to get the Company State properly.!', 'error');
                            return;
                        }
                        let companyState = localStorage.getItem('companyState');

                        if (data[2].LabelValue !== companyState) {
                            setTaxMode(1);
                        } else {
                            setTaxMode(0);
                        }
                    })
                    .catch(error => {
                        showError('Unable to get the address properly.!', 'error');
                    });
            }
        }

    };



    const LoadInvoiceOrderCombinedInvoicePrint = async (params) => {

        const requestBody = {
            IParentInvoiceOrder_ID: params.InvoicePlanNo,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
                LOGIN_USER: LOGIN_USER
            },
        };

        fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice_Print, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load invoice order for update');
                }
                return response.json();
            })
            .then(data => {
                SetheaderDespatchplan(data.SOrderStatus + " Invoice Order");
                SetSInvoiceNo(data.SInvoiceNo);
                set_IParentInvoiceOrder_ID(data.SParentInvoiceOrder_ID);

                if (data.SInvoiceNo && data.SInvoiceNo.trim() !== "") {
                    set_bOrderInvoiced(true);
                }
                if (data.SInvoiceDate != null) {
                    setOrderDate(data.SInvoiceDate);
                }

                set_minInvoiceDate(data.SShipmentPlanDate);
                setDistance(data.Distanceinkm);
                setLRNumber(data.SLRNo);
                setLRDate(data.SLRDate ? dayjs(data.SLRDate) : null);
                setTruckNumber(data.TruckNumber);
                setSupplyType(data.SupplyType);

                handleFilterAndSetSelection(dataCustomer, setSelectedCustomer, 'SBillToCustomer', data, setBillToCustomer);
                handleFilterAndSetSelection(dataSupplier, setSelectedSupplier, 'SShipToCustomer', data, setSupplier);
                handleFilterAndSetSelection(dataPricelist, setSelectedPricelist, 'SPriceList', data, setPriceList);
                handleFilterAndSetSelection(dataTransporter, setSelectedTransporter, 'STransporter', data, setSTransporter);

                handleFilterAndSetSelection(dataShipmentmode, setSelectedShipmentMode, 'SShipmentMode', data, setId_ShipmentMode);
                handleFilterAndSetSelection(dataPaymentterm, setSelectedPaymentTerm, 'SPaymentTerm', data, setId_PaymentTerm);
                handleFilterAndSetSelection(dataCreditterm, setSelectedCreditTerm, 'SCreditTerm', data, setId_CreditTerm);
                handleFilterAndSetSelection(dataCredittermRule, setSelectedCreditTermRule, 'SCreditLimitRule', data, setId_CreditTermRule);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                SetRemarks(data.SRemarks);
                SetSRefNo(data.SRefNo);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    const SShipmentPlanDate = new Date(row.SShipmentPlanDate).toLocaleDateString();
                    return { ...row, id: index + 1, SShipmentPlanDate };
                });

                setManualTCSRate(data.TcsRate);
                setrowsConfirmedOrdersDespacth(fdata);
                setHeaderData(data);

                const fdata3 = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus(params.InvoiceStatus);
                setViewCancelDetail(false);
                handleOrderItemCalculation(data, fdata);
                CalculateSummaryForProducts();
            })
            .catch(error => {

                showError('Unable to load invoice order for update', 'error');
            });
    }



    // new row wise calculation functions [thitavidam 15-10-25]

    // declartion for summary 
    const [totals, setTotals] = useState({
        TotalQty: 0,
        totalAmountExclDiscount: 0,
        totalDiscount: 0,
        totalAmountAfterDiscount: 0,
        freightAmount: 0,
        insuranceAmount: 0,
        serviceChargeAmount: 0,
        totalTaxableAmount: 0,
        totalGSTAmount: 0,
        totalCessAmount: 0,
        roundOff: 0,
        tcsAmount: 0,
        netAmountWithRounding: 0,
        salesAmount: 0,
        cgstRate: 0,
        sgstRate: 0,
        igstRate: 0,
        discountRate: 0,
        discountType: 'Flat',
        freightRate: 0,
        insurancePercentage: 0,
        serviceCharge: 0,
        tcsPercentage: 0,
        igstAmount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        cessRate: 0,

    });

    // Input data from your React state or props
    const supplierAddr = [
        { LabelName: "State", LabelValue: "Maharashtra" },
    ];

    const billToAddr = [
        { LabelName: "State", LabelValue: "Gujarat" },
    ];

    const handleOrderItemCalculation = async (header, items) => {

        let totalQty = 0;
        let totalAmountExclDiscount = 0;
        let totalAmountAfterDiscount = 0;
        let totalDiscount = 0;
        let totalTaxAmount = 0;

        let cessRate = header.CessRate;
        let freightRate = header.FreightPerMT;
        let insuranceRate = header.insuranceRatePct || 0;
        let serviceChargeRate = header.ServiceChargeRate;

        // let cessRate = 1;
        // let freightRate = 1;
        // let insuranceRate = 1;
        // let serviceChargeRate = 1;

        // const originState = supplierAddr.find(
        //     (x) => x.LabelName?.toLowerCase() === "state"
        // )?.LabelValue?.toLowerCase();

        // const destinationState = billToAddr.find(
        //     (x) => x.LabelName?.toLowerCase() === "state"
        // )?.LabelValue?.toLowerCase();

        let isInterState = taxMode; //taxMode;//originState !== destinationState;
        isInterState = taxMode === 0 ? true : false;

        const taxBreakdown = [];
        let discountType = 'rate';
        let discountValue = 0;

        let isExportOrder = false;
        let isDomesticOrder = false;

        const round2 = (num) =>
            Number(Number(num).toFixed(2));


        const rows = items.map((row) => {

            let lineQty = row.SIRequested_Qty || 0;
            if (row.SIConfirmed_Qty > 0) lineQty = row.SIConfirmed_Qty;
            if (row.SIPlanned_Qty > 0) lineQty = row.SIPlanned_Qty;
            if (row.SIShipped_Qty > 0) lineQty = row.SIShipped_Qty;

            const lineUnitPrice = row.SIUnitPrice || 0;
            //discountValue = row.SIDiscount || 0;
            //const discountValue = 0;
            discountType = row.SIDiscountType?.toLowerCase();
            let discountedUnitPrice = lineUnitPrice;
            let lineDiscountAmt = 0;

            if (discountValue > 0) {
                if (discountType === "rate") {
                    discountedUnitPrice = lineUnitPrice - (lineUnitPrice * discountValue) / 100;
                    lineDiscountAmt = lineQty * ((lineUnitPrice * discountValue) / 100);
                } else {
                    discountedUnitPrice = lineUnitPrice - discountValue;
                    lineDiscountAmt = lineQty * discountValue;
                }
            }

            const lineAmount = round2(lineQty * lineUnitPrice);
            lineDiscountAmt = round2(lineDiscountAmt);
            const afterDiscount = round2(lineAmount - lineDiscountAmt);

            // Convert quantity to kg
            if (row.SIUnit?.toLowerCase() === "ton") lineQty *= 1000;

            const insuranceAmt = round2((afterDiscount * insuranceRate) / 100);
            const freightAmt = round2((lineQty / 1000) * freightRate);
            const serviceChargeAmt = round2((afterDiscount * serviceChargeRate) / 100);
            const taxableValue = round2(afterDiscount + insuranceAmt + serviceChargeAmt);

            let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;

            if (isInterState) {
                if (row.SIIGSTPercent > 0) {
                    igstAmt = round2((taxableValue * row.SIIGSTPercent) / 100);
                    taxBreakdown.push({
                        TaxCategory: "IGST Tax",
                        TaxPercent: row.SIIGSTPercent,
                        TaxableAmount: taxableValue,
                        TaxAmount: igstAmt,
                    });
                }
            } else {
                if (row.SICGSTPercent > 0) {
                    cgstAmt = round2((taxableValue * row.SICGSTPercent) / 100);
                    taxBreakdown.push({
                        TaxCategory: "CGST Tax",
                        TaxPercent: row.SICGSTPercent,
                        TaxableAmount: taxableValue,
                        TaxAmount: cgstAmt,
                    });
                }
                if (row.SISGSTPercent > 0) {
                    sgstAmt = round2((taxableValue * row.SISGSTPercent) / 100);
                    taxBreakdown.push({
                        TaxCategory: "SGST Tax",
                        TaxPercent: row.SISGSTPercent,
                        TaxableAmount: taxableValue,
                        TaxAmount: sgstAmt,
                    });
                }
            }

            const lineTaxAmount = isInterState ? igstAmt : cgstAmt + sgstAmt;
            const cessAmt = round2((lineTaxAmount * cessRate) / 100);

            const totalLineAmount = round2(
                afterDiscount + insuranceAmt + serviceChargeAmt + cessAmt + lineTaxAmount
            );

            totalQty += lineQty;
            totalAmountExclDiscount += lineAmount;
            totalTaxAmount += lineTaxAmount;
            totalDiscount += lineDiscountAmt;
            totalAmountAfterDiscount += afterDiscount;



            return {
                ...row,
                SILineTaxableAmount: taxableValue,
                SIDiscountAmount: lineDiscountAmt,
                SICGSTAmount: cgstAmt,
                SISGSTAmount: sgstAmt,
                SIIGSTAmount: igstAmt,
                SICessAmount: cessAmt,
                SIFreightAmount: freightAmt,
                SIInsuranceAmount: insuranceAmt,
                SIServiceChargeAmount: serviceChargeAmt,
                SIBeforeDiscountAmount: lineAmount,
                SIAfterDiscountAmount: afterDiscount,
                SILineTaxAmount: totalLineAmount,
            };
        });


        // Fright, Insurance, Service charge amount caluculations
        const freightAmount = round2((totalQty / 1000) * freightRate);

        const insuranceAmount = round2(
            ((freightAmount + totalAmountAfterDiscount) * insuranceRate) / 100
        );

        const serviceChargeAmount = round2(
            (totalAmountAfterDiscount * serviceChargeRate) / 100
        );

        const totalTaxableAmount = round2(
            totalAmountAfterDiscount + insuranceAmount + freightAmount + serviceChargeAmount
        );

        // gst summary calculations
        let cgstRate = 0, sgstRate = 0, igstRate = 0;
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (!isExportOrder) {
            if (isInterState) {

                igstRate = items[0].SIIGSTPercent || 0;
                igstAmount = round2((totalTaxableAmount * igstRate) / 100);
                taxBreakdown.push({
                    TaxCategory: "IGST Tax",
                    TaxPercent: igstRate,
                    TaxableAmount: totalTaxableAmount,
                    TaxAmount: igstAmount,
                });
            } else {
                cgstRate = items[0]?.SICGSTPercent || 0;
                sgstRate = items[0]?.SISGSTPercent || 0;
                cgstAmount = round2((totalTaxableAmount * cgstRate) / 100);
                sgstAmount = round2((totalTaxableAmount * sgstRate) / 100);
                taxBreakdown.push(
                    {
                        TaxCategory: "CGST Tax",
                        TaxPercent: cgstRate,
                        TaxableAmount: totalTaxableAmount,
                        TaxAmount: cgstAmount,
                    },
                    {
                        TaxCategory: "SGST Tax",
                        TaxPercent: sgstRate,
                        TaxableAmount: totalTaxableAmount,
                        TaxAmount: sgstAmount,
                    }
                );
            }
        }

        const totalGSTAmount = round2(igstAmount + cgstAmount + sgstAmount);

        // cess calculations
        const totalCessAmount = round2((totalGSTAmount * cessRate) / 100);

        // net amount calculations
        let netAmountWithoutRounding = round2(totalAmountAfterDiscount + insuranceAmount + freightAmount + serviceChargeAmount + totalCessAmount + totalGSTAmount);
        let netAmountWithRounding = Math.round(netAmountWithoutRounding);
        const roundOff = round2(netAmountWithRounding - netAmountWithoutRounding);
        let salesAmount = netAmountWithRounding;

        // get tcs value 
        let tcsData = await getParemeterDetail(14);

        // TCS calculations
        let tcsAmount = 0;
        let bTCSApplicable = false;
        let mTCSRate = 0;
        let mTCSThresoldAmount = 0;
        let bManualTCSCalculation = true;
        let bPartyTCSControlledByFlag = true;
        let tcsRate = 0;
        let bPartyTCSApplicable = false;
        let mCurrentSaleValue = headerData.CurrentSaleValue;
        let mOrderStatus = 'Invoiced';

        if (defaultParameterConfig[0]?.p_default_value_code === '1') {
            bTCSApplicable = true;
            mTCSRate = parseFloat(defaultParameterConfig[0].p_minvalue);
            mTCSThresoldAmount = parseFloat(defaultParameterConfig[0].p_maxvalue);
            bManualTCSCalculation = parseFloat(defaultParameterConfig[0].p_enableui);
            bPartyTCSControlledByFlag = (defaultParameterConfig[0].p_default_value);

        }

        setManualTCSRateEdit(bManualTCSCalculation);

        const oTCSRate = Number(tcsRate || 0);          // UI supplied TCS rate (oTCSRate)
        const manualTCS = !!bManualTCSCalculation;      // boolean
        const partyControlFlag = !!bPartyTCSControlledByFlag; // boolean
        const partyTCSApplicable = !!bPartyTCSApplicable;     // boolean (fallback false if undefined)
        const currentSale = Number(mCurrentSaleValue || 0);
        const orderStatus = (mOrderStatus || "").toString();

        let mTCSAmount = 0; // VB's mTCSAmount

        if (Boolean(bTCSApplicable)) {
            // default TCS base = rounded net amount (netAmountWithRounding computed earlier)
            let TCSOnValue = netAmountWithRounding;

            if (manualTCS) {
                // Total manual control: use UI-entered rate (oTCSRate)
                mTCSAmount = Math.round((TCSOnValue * oTCSRate) / 100); // rounded to 0 decimals

            } else if (partyControlFlag) {
                // Controlled by Party Master: use mTCSRate if party is applicable, otherwise tmp rate = 0
                if (partyTCSApplicable) {
                    // show rate mTCSRate in UI (if you want to set a textbox/state)
                    // e.g. setTcsRateDisplay(Number(mTCSRate).toFixed(2))
                    mTCSAmount = Math.round((TCSOnValue * Number(mTCSRate || 0)) / 100);
                } else {
                    const tmpTCSRate = 0;
                    // setTcsRateDisplay(tmpTCSRate.toFixed(2))
                    mTCSAmount = Math.round((TCSOnValue * tmpTCSRate) / 100);
                }
            } else {
                // Auto TCS Calculation — based on cumulative sales threshold
                let CurrentTotalSaleValue = currentSale + totalTaxableAmount; // totalTaxableAmount computed earlier
                mTCSAmount = 0;

                // Only calculate if CurrentTotalSaleValue > threshold and order not already Invoiced
                if (CurrentTotalSaleValue > Number(mTCSThresoldAmount || 0) &&
                    orderStatus.toLowerCase() !== "invoiced") {

                    if (currentSale < Number(mTCSThresoldAmount || 0)) {
                        // Consider only the portion above threshold
                        TCSOnValue = currentSale + netAmountWithRounding - Number(mTCSThresoldAmount || 0);
                    }

                    // show rate mTCSRate in UI: setTcsRateDisplay(Number(mTCSRate).toFixed(2))
                    mTCSAmount = Math.round((TCSOnValue * Number(mTCSRate || 0)) / 100);
                }
            }
        }

        // expose TCS results in variables used later
        tcsAmount = Number(mTCSAmount || 0);

        // add TCS to net amount (same behavior as VB: add mTCSAmount after rounding)
        netAmountWithRounding = Number(netAmountWithRounding || 0) + tcsAmount;

        // list out summary details
        const totalSummary = {
            TotalQty: totalQty,
            totalAmountExclDiscount: totalAmountExclDiscount,
            totalDiscount: totalDiscount,
            totalAmountAfterDiscount: totalAmountAfterDiscount,
            freightAmount: freightAmount,
            insuranceAmount: insuranceAmount,
            serviceChargeAmount: serviceChargeAmount,
            totalTaxableAmount: totalTaxableAmount,
            totalGSTAmount: totalGSTAmount,
            totalCessAmount: totalCessAmount,
            roundOff: roundOff,
            tcsAmount: tcsAmount,
            netAmountWithRounding: netAmountWithRounding,
            salesAmount: salesAmount,
            cgstRate: cgstRate,
            sgstRate: sgstRate,
            igstRate: igstRate,
            discountRate: discountValue,
            discountType: discountType,
            freightRate: freightRate,
            insurancePercentage: insuranceRate,
            serviceCharge: serviceChargeRate,
            tcsPercentage: tcsRate,
            igstAmount: igstAmount,
            cgstAmount: cgstAmount,
            sgstAmount: sgstAmount,
            cessRate: cessRate,

        };


        setTotals(totalSummary);

        setrowsConfirmedOrdersDespacth(rows);

    }



    const CalculateSummaryForProducts = () => {
        let totalSIConfirmedQty = 0;
        let totalGrossAmount = 0;
        let oTotalDiscountAmount = 0;

        rowsConfirmedOrdersDespacth.forEach((row) => {
            const newRowSIConfirmedQty = parseFloat(row.SIConfirmed_Qty);
            const newRowSIUnitPrice = parseFloat(row.SIUnitPrice);
            const newRowSIDiscount = parseFloat(row.SIDiscount);
            const DiscountType = row.SIDiscountType;

            if (newRowSIDiscount > 0) {
                if (DiscountType === 'rate') {
                    oTotalDiscountAmount += newRowSIConfirmedQty * ((newRowSIUnitPrice * newRowSIDiscount) / 100)
                }
                else {
                    oTotalDiscountAmount += newRowSIConfirmedQty * newRowSIDiscount
                }
            }
            totalSIConfirmedQty += newRowSIConfirmedQty;
            totalGrossAmount += newRowSIConfirmedQty * newRowSIUnitPrice;
        });

        // Set the totals in the state
        set_totalSIConfirmedQty(totalSIConfirmedQty);
        set_totalGrossAmount(totalGrossAmount);
        settotaldiscountAmount(oTotalDiscountAmount);
        settotalAmount(oTotalDiscountAmount);
    }

    const RefreshStatus = (status) => {
        setbtnApprove(false);
        setbtnSaveUpdateOrdershow(false);
        setbtnAmendmentshow(false);
        setbtnPrint(false);
        setbtnCancel(false);
        setvisibleAmendmentReason(false);
        set_btnGenerateInvoice(false);

        if (status === 'New' || status === '[New]') {
            SetheaderDespatchplan('New Invoice Order')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Processed') {
            SetheaderDespatchplan('Invoice Order in Process')
            setbtnPrint(true);
        }
        else if (status === 'UnderAmendment') {
            SetheaderDespatchplan('Amended Invoice Order')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Cancelled') {
            SetheaderDespatchplan('Invoice Order Cancelled')
        }
        else if (status === 'Approved') {
            SetheaderDespatchplan('Approved Invoice Order')
            setbtnCancel(true);
            setbtnAmendmentshow(true);
            setvisibleAmendmentReason(true);
            set_btnGenerateInvoice(true);
        }
        else if (status === 'Invoiced') {
            SetheaderDespatchplan('Invoiced Order List')
            setbtnCancel(true);
            setbtnPrint(true);
            setbtnAmendmentshow(true);
            setvisibleAmendmentReason(true);
        }
        setViewCreateDespatchPlan(false);
        setViewCreateInvoiceEntry(true);
        setViewCommonButton(true);
        setisVisible_DespatchItem(false);
    }

    const handleEnterReason = (e) => {
        SetReason(e.target.value);
    }
    const handleDateChange = (date) => {
        const selectedDate = new Date(date); // Assuming 'date' is a valid date string
        const formattedDate = selectedDate.toLocaleDateString('en-US');
        setSelectedDate(formattedDate);
    };

    const handleSelectAmendmentReason = (e) => {
        SetSAmendmentReason(e.target.value);
    }


    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setrowsConfirmedOrdersDespacth(rowsConfirmedOrdersDespacth.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            const id = 0;
            setrowsConfirmedOrdersDespacth((oldRows) => [...oldRows, { id, name: '', age: '', isNew: true }]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            }));
        };

        return (
            <GridToolbarContainer>
                {/* <Button color="primary"  onClick={handleClick}>
              Add record
            </Button> */}
            </GridToolbarContainer>
        );
    }

    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);
    const [headerData, setHeaderData] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});


    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);
    const [plannedQtyData, setplannedQtyData] = useState([]);

    useEffect(() => {
        const handleResize = () => {
            setGridAutoRows(calculateGridAutoRows());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        LoadInoviceOrderList();
        LoadConfirmedOrderList();

    }, []);

    function calculateGridAutoRows() {
        const screenHeight = window.innerHeight;
        const rows = Math.floor((screenHeight - 70) / 3); // Adjust 50 as needed for margins or paddings
        return `${rows}px`;
    }

    const handleClose = () => {
        setOpen(false);

        const updatedReelRows = rowsReelItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsReelItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });
        setrowsReelItems(updatedReelRows);

        const updatedsheetRows = rowsSheetItems.map(row => {
            const filteredRow = rowsSheetItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            if (filteredRow && filteredRow.id === row.id) {
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                return row;
            }
        });

        setrowsSheetItems(updatedsheetRows);

    };




    const handleSubmitConfirmationOrder = (event) => {
        event.preventDefault();

        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadConfirmedOrderList();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            handleBackTofromConnfrimOrderList();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, handleShowDispatchPlansEntry, handleBackTofromDespacthPlanEntry]);


    const handleCheckboxChangeForConfirmationOrder = (event, rowId) => {
        const updatedRows = rowsConfirmedOrders.map(row =>
            row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
        );
        setrowsConfirmedOrders(updatedRows);

        const filteredData = updatedRows.filter(row => row.SelectItem === true);
        setselectCOOrders(filteredData);
    };


    function validateItemList() {
        let isFormDataValid = false;

        rowsConfirmedOrdersDespacth.forEach((row) => {
            if (row.SIUnitPrice === 0) {
                showError("Unit price is a required field", "error");
                isFormDataValid = true;
                return;
            } else if (row.SIDiscount === 0 && row.SIDiscountType !== "0" && row.SIDiscountType !== "") {
                showError("Discount value is a required field", "error");
                isFormDataValid = true;
                return;
            } else if (row.SIDiscount > 0 && (row.SIDiscountType === "0" || row.SIDiscountType === "")) {
                showError("Discount type is a required field", "error");
                isFormDataValid = true;
                return;
            }
        });

        return isFormDataValid;
    }


    const handleCancelInvoice = () => {

        try {
            let formDirty = false;

            if (!formDirty) {
                if (cancelDate === '') {
                    showError('Cancel date is a required field', 'error');
                    return;
                }
                else if (Reason === '') {
                    showError('Cancel Reason is a required field', 'error');
                    SetcancelReasonFoucs(true);
                    return;
                }
                else {
                    const confirm = window.confirm(`Are you sure want to Cancel this order?, Confirm Cancellation`);

                    if (!confirm) {
                        return;
                    }

                    setOpenAlert(false);
                    setLoading(true);

                    const formattedDate = dayjs(cancelDate).format('YYYY-MMM-DD');

                    const clsInvoiceOrder = {
                        DespatchOrderId: iDespatchOrderIdList,
                        ShippedOrderId: iShippedOrderIdList,
                        InvoiceOrderId: iInvoiceOrderIdList,
                        ConfirmationOrderId: iConfirmationIdList,
                        SInvoiceNo: SInvoiceNo,
                        SOrderStatus: "Cancelled",
                        SCancelledReason: Reason,
                        InvoicePlanNo: IParentInvoiceOrder_ID,
                        SCancelledDate: formattedDate
                    };

                    const requestBody = {
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.CancelInvoiceOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to cancel invoice')
                            }
                            return response.json();
                        })
                        .then(data => {
                            showError(data.returnmsg, 'success');
                            LoadInoviceOrderList();
                            RefreshStatus(data.clsInvoiceOrder.SOrderStatus);
                        })
                        .catch(error => {
                            showError('Unable to cancel invoice.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    let ApproveAndAmend;
    const handleApproveAndAmendInvoice = (actionType) => {
        try {
            let formDirty = false;


            if (actionType === 'Approve Invoice') {
                const confirm = window.confirm(`This will Approve the order for invoice creation. Would you like to continue?, Approve Order`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Approve';
            }
            else if (actionType === 'Amend Invoice') {
                const confirm = window.confirm(`This will allow amendment for the order. Would you like to continue?, Amend Order`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Amend';

                if (SAmendmentReason === '') {
                    formDirty = showError('Amendment Reason is a required field', 'error');
                    SetamendmentReasonFoucs(true);
                }
            }

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {


                    setOpenAlert(false);
                    setLoading(true);

                    handleSaveInvoiceOrder(false);


                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    const handleSaveInvoiceOrder = (param) => {
        try {
            let formDirty = false;
            formDirty = validateItemList();



            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {
                    if (sameParty) {
                        const userConfirmed = window.confirm(
                            "Different party orders are chosen and will be converted to a single customer during invoice creation.\nAre you sure you want to continue?"
                        );

                        if (!userConfirmed) {
                            return false;
                        }
                    }


                    setOpenAlert(false);
                    setLoading(true);

                    const formattedOrderDate = dayjs(OrderDate).format('YYYY-MMM-DD');
                    const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MMM-DD');

                    const clsInvoiceOrder = {
                        DespatchOrderIdList: iDespatchOrderIdList,
                        ShippedOrderIdList: iShippedOrderIdList,
                        InvoiceOrderIdList: iInvoiceOrderIdList,
                        ConfirmationOrderIdList: iConfirmationIdList,
                        SParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        SInvoiceNo: SInvoiceNo,
                        SInvoiceDate: formattedOrderDate,
                        SBillToCustomer: SBillToCustomer,
                        SShipToCustomer: SShipToCustomer,
                        SSupplier: 0,
                        SManufacturer: 0,
                        SRefNo: SRefNo,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: Remarks,
                        SScheduledDate: formattedScheduleDate,
                        SPriceList: Pricelistid,
                        SPaymentTerm: Id_PaymentTerm,
                        STransporter: STransporter,
                        SShipmentMode: Id_ShipmentMode,
                        SCreditTerm: Id_CreditTerm,
                        SCreditLimitRule: Id_CreditTermRule,
                        SLocation: 0,
                        TotalQty: totalSIConfirmedQty,
                        BasicAmount: totalGrossAmount,
                        GrossAmount: totalGrossAmount,
                        DiscountAmount: totaldiscountAmount,
                        GrossAmountAfterDiscount: totalAmount,
                        InsuranceRate: totals.insurancePercentage,
                        InsuranceAmount: totals.insuranceAmount,
                        FreightPerMT: totals.freightRate,
                        FreightAmount: totals.freightAmount,
                        ServiceChargeRate: totals.serviceCharge,
                        ServiceChargesAmount: totals.serviceChargeAmount,
                        TaxableAmount: totals.totalTaxableAmount,
                        CessAmount: totals.totalCessAmount,
                        TaxAmount: totals.totalGSTAmount,
                        NetAmountRoundOff: totals.roundOff,
                        NetAmountRounded: totals.netAmountWithRounding,
                        CessRate: totals.cessRate,
                        CGSTRate: totals.cgstRate,
                        SGSTRate: totals.sgstRate,
                        IGSTRate: totals.igstRate,
                        CGSTAmount: totals.cgstAmount,
                        SGSTAmount: totals.sgstAmount,
                        IGSTAmount: totals.igstAmount,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                        Distanceinkm: parseInt(distance),
                        Paymentterm_id: Id_PaymentTerm,
                        Saleamount: totals.salesAmount,
                        Tcsrate: totals.tcsPercentage,
                        Tcsamount: totals.tcsAmount
                    };

                    const requestBody = {
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.saveInvoiceOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to save invoice order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (param) {
                                showError(data.returnmsg, 'success');
                            }
                            let parentInvoiceOrderID;
                            setBtnSaveText(data.BtnText);
                            setBtnSaveTooltip(data.BtnText, ' Invoice');
                            set_IParentInvoiceOrder_ID(data.clsInvoiceOrder.SParentInvoiceOrder_ID)
                            parentInvoiceOrderID = data.clsInvoiceOrder.SParentInvoiceOrder_ID;
                            LoadInoviceOrderList();
                            LoadConfirmedOrderList();
                            RefreshStatus('New');

                            if (param === false) {
                                AmendAndApproveProcess(parentInvoiceOrderID);

                            }
                        })
                        .catch(error => {
                            showError('Unable to save invoice order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {

            console.error('Error:', error);

        } finally {

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    const AmendAndApproveProcess = (parentInvoiceOrderID) => {
        const formattedOrderDate = dayjs(OrderDate).format('YYYY-MMM-DD');
        const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MMM-DD');

        const clsInvoiceOrder = {
            DespatchOrderIdList: iDespatchOrderIdList,
            ShippedOrderIdList: iShippedOrderIdList,
            InvoiceOrderIdList: iInvoiceOrderIdList,
            ConfirmationOrderIdList: iConfirmationIdList,
            SInvoiceNo: SInvoiceNo,
            SParentInvoiceOrder_ID: parentInvoiceOrderID,
            InvoicePlanNo: parentInvoiceOrderID,
            SInvoiceDate: formattedOrderDate,
            SBillToCustomer: SBillToCustomer,
            SShipToCustomer: SShipToCustomer,
            SSupplier: 0,
            SManufacturer: 0,
            SRefNo: SRefNo,
            LastUpdatedBy: LOGIN_USER,
            SRemarks: Remarks,
            SScheduledDate: formattedScheduleDate,
            SPriceList: Pricelistid,
            SPaymentTerm: Id_PaymentTerm,
            STransporter: STransporter,
            SShipmentMode: Id_ShipmentMode,
            SCreditTerm: Id_CreditTerm,
            SCreditLimitRule: Id_CreditTermRule,
            SLocation: 0,
            TotalQty: totalSIConfirmedQty,
            BasicAmount: totalGrossAmount,
            GrossAmount: totalGrossAmount,
            DiscountAmount: totaldiscountAmount,
            GrossAmountAfterDiscount: totalAmount,
            InsuranceRate: 0,
            InsuranceAmount: 0,
            FreightPerMT: 0,
            FreightAmount: 0,
            ServiceChargeRate: 0,
            ServiceChargesAmount: 0,
            TaxableAmount: 0,
            CessAmount: 0,
            TaxAmount: 0,
            NetAmountRoundOff: 0,
            NetAmountRounded: 0,
            CessRate: 0,
            CGSTRate: 0,
            SGSTRate: 0,
            IGSTRate: 0,
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            SAmendmentReason: SAmendmentReason,
            SSalesOrderItems: rowsConfirmedOrdersDespacth,
        };

        const requestBody = {
            ApproveAndAmend: ApproveAndAmend,
            clsInvoiceOrder: clsInvoiceOrder,
            bOrderInvoiced: bOrderInvoiced,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
                LOGIN_USER: LOGIN_USER
            },
        };

        fetch(API_ENDPOINTS.approve_amend_InvoiceOrderDetails, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to approve Invoice order')
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');

                LoadInoviceOrderList();
                RefreshStatus(data.clsInvoiceOrder.SOrderStatus);
            })
            .catch(error => {
                showError('Unable to approve Invoice order.!', 'error');
            });
    }

    const handleGenerateInvoiceOrder = () => {


        try {
            let formDirty = false;



            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {
                    setOpenAlert(false);
                    setLoading(true);

                    const formattedOrderDate = dayjs(OrderDate).format('YYYY-MMM-DD');
                    const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MMM-DD');

                    const clsInvoiceOrder = {
                        SOrderStatus: headerDespatchplan,
                        DespatchOrderIdList: iDespatchOrderIdList,
                        ShippedOrderIdList: iShippedOrderIdList,
                        InvoiceOrderIdList: iInvoiceOrderIdList,
                        ConfirmationOrderIdList: iConfirmationIdList,
                        InvoicePlanNo: IParentInvoiceOrder_ID,
                        SParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        SInvoiceNo: SInvoiceNo,
                        SInvoiceDate: formattedOrderDate,
                        SBillToCustomer: SBillToCustomer,
                        SShipToCustomer: SShipToCustomer,
                        SSupplier: 0,
                        SManufacturer: 0,
                        SRefNo: SRefNo,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: Remarks,
                        SScheduledDate: formattedScheduleDate,
                        SPriceList: Pricelistid,
                        SPaymentTerm: Id_PaymentTerm,
                        STransporter: STransporter,
                        SShipmentMode: Id_ShipmentMode,
                        SCreditTerm: Id_CreditTerm,
                        SCreditLimitRule: Id_CreditTermRule,
                        SLocation: 0,
                        TotalQty: totalSIConfirmedQty,
                        BasicAmount: totalGrossAmount,
                        GrossAmount: totalGrossAmount,
                        DiscountAmount: totaldiscountAmount,
                        GrossAmountAfterDiscount: totalAmount,
                        InsuranceRate: 0,
                        InsuranceAmount: 0,
                        FreightPerMT: 0,
                        FreightAmount: 0,
                        ServiceChargeRate: 0,
                        ServiceChargesAmount: 0,
                        TaxableAmount: 0,
                        CessAmount: 0,
                        TaxAmount: 0,
                        NetAmountRoundOff: 0,
                        NetAmountRounded: 0,
                        CessRate: 0,
                        CGSTRate: 0,
                        SGSTRate: 0,
                        IGSTRate: 0,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        IGSTAmount: 0,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                    };

                    const requestBody = {
                        DocumentSeries: DocumentSeries,
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },

                        filter: {
                            FinancierYear: FinancierYear,
                            CompanyID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.GenerateInvoiceOrder, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to generate invoice order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (data.returnmsg === 'This Invoice No Generated Successfully') {
                                showError(data.returnmsg, 'success');
                            }
                            else {
                                showError(data.returnmsg, 'error');
                            }
                            SetSInvoiceNo(data.clsInvoiceOrder.SInvoiceNo);
                            setBtnSaveText(data.BtnText);
                            setBtnSaveTooltip(data.BtnText, ' Invoice');

                            LoadInoviceOrderList();
                            LoadConfirmedOrderList();

                            RefreshStatus('Invoiced');
                        })
                        .catch(error => {
                            showError('Unable to save invoice order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {

            console.error('Error:', error);

        } finally {

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };





    const [selectedStatus, setSelectedStatus] = useState('All');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRows_orders, setSelectedRows_orders] = useState([]);

    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);

    const [selectedOptionFirstOrder, setSelectedOptionFirstOrder] = useState('All Delivery Order');


    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [open1, setOpen1] = useState(false);
    const isSelected_Invoice = (rowId) => selectedRows.indexOf(rowId) !== -1;
    const isSelected1_order = (rowId) => selectedRows_orders.indexOf(rowId) !== -1;

    const [filters, setFilters] = useState({
        ProductGroup: '',
        ProductSubGroup: '',
        ProductVariety: '',
        Code: '',
        Name: '',
    });



    const filteredData_orders = rowsConfirmedOrders.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.InvoiceStatus === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });




    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = rows.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };





    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };

    // const handleFilterChange = (event) => {
    //     const { name, value } = event.target;
    //     setFilters({ ...filters, [name]: value });
    // };


    const handleRowCheckboxClickDeliveryOrder = (event, rowId) => {
        const selectedIndex = selectedRows_orders.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows_orders, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows_orders.slice(1);
        } else if (selectedIndex === selectedRows_orders.length - 1) {
            newSelectedRows = selectedRows_orders.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows_orders.slice(0, selectedIndex),
                ...selectedRows_orders.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows_orders(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        }
        else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }

        handleCheckboxChangeForConfirmationOrder(event, rowId)
    };



    const handleMenuItemClickFirstForOrder = (option) => {
        setSelectedOptionFirstOrder(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Delivery Order') {
            setSelectedStatus('All');
        }

        setAnchorElFirst(null);
    };


    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [viewInvoiceDetail, setInvoiceDetail] = useState(true);

    const handlePackinglistcallback = () => {
        setInvoiceDetail(true);
        setViewPackingList(false);
        setViewInvoiceReport(false);
    }
    const handleInvoicelistcallback = () => {
        setInvoiceDetail(true);
        setViewPackingList(false);
        setViewInvoiceReport(false);
    }


    // json file convertion

    // Helper to mimic DALHelper.ConvertToBlankValue / ConvertToZeroValue
    const convertToBlank = (v) => (v === null || v === undefined ? "" : String(v));
    const convertToZero = (v) => toDecimal(v, 0);

    function mapRowValue(rows, rowIndex, colIndex, fallback = "") {
        // try to be flexible: rows may be array of arrays, or array of objects with numeric keys
        if (!rows || !rows[rowIndex]) return fallback;
        const row = rows[rowIndex];
        return row[colIndex] !== undefined ? row[colIndex] : fallback;
    }

    // 
    const [supplyType, setSupplyType] = useState('B2B');
    const [regRev, setRegRev] = useState('N');
    const [igstOnIntra, setIgstOnIntra] = useState('N');


    const handleLoadInvoiceDetails = async () => {
        try {
            if (!IParentInvoiceOrder_ID || IParentInvoiceOrder_ID === 0) {
                showError('Invalid Parent Invoice Order ID!', 'warning');
                return;
            }

            const requestBody = {
                IParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: localStorage.getItem('companyid'),
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            const response = await callApi(
                API_ENDPOINTS.REPORT_INVOICE_ALL_COPIES,
                'POST',
                { 'Content-Type': 'application/json' },
                requestBody
            );

            if (response[0].invoice_detail && response[0].invoice_detail.length > 0) {
                if (response && response.length > 0) {
                    setInvoiceList(response);
                    return response;
                }

            } else {
                showError('No data found for the selected Invoice Order!', 'info');
            }
        } catch (error) {
            console.error('Error loading packing list:', error);
            showError('Failed to generate packing list.', 'error');
        }
    }

    async function buildInvoiceObject() {
        let response;
        try {
            if (!IParentInvoiceOrder_ID || IParentInvoiceOrder_ID === 0) {
                showError('Invalid Parent Invoice Order ID!', 'warning');
                return;
            }

            const requestBody = {
                IParentInvoiceOrder_ID,
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: localStorage.getItem('companyid'),
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            response = await callApi(
                API_ENDPOINTS.REPORT_INVOICE_ALL_COPIES,
                'POST',
                { 'Content-Type': 'application/json' },
                requestBody
            );

            // ✅ Validate response properly
            if (!response || !Array.isArray(response) || response.length === 0) {
                showError('No data found for the selected Invoice Order!', 'info');
                return;
            }

            const dataToUse = response[0] || {};
            const header = dataToUse.invoice_detail?.[0] || {};
            const itemsData = dataToUse.invoice_items || [];

            // ✅ Optional: set state if you need to show invoice list somewhere
            setInvoiceList(response);

            // ✅ Construct report data safely
            const defaultReportData = {
                Header: {
                    InvoiceNo: header.invoiceno || "",
                    InvoiceDate: header.invoicedate || "",
                },
                Buyer: {
                    Name: header.billtoname || "",
                    AddressLine1: header.billto_addrline1 || "",
                    AddressLine2: header.billto_addrline2 || "",
                    City: header.billto_addrcity || "",
                    Pincode: header.billto_addrpincode || "",
                    GSTIN: header.billto_gstno || "",
                    State: header.billto_addrstate || "",
                    Code: header.billto_gststatecode || "",
                },
                Consignee: {
                    Name: header.shiptoname || "",
                    AddressLine1: header.shipto_addrline1 || "",
                    AddressLine2: header.shipto_addrline2 || "",
                    City: header.shipto_addrcity || "",
                    Pincode: header.shipto_addrpincode || "",
                    GSTIN: header.shipto_gstno || "",
                    State: header.shipto_addrstate || "",
                    Code: header.shipto_gststatecode || "",
                },
                Seller: {
                    Name: header.companyname || "",
                    AddressLine1: header.company_addrline1 || "",
                    AddressLine2: header.company_addrline2 || "",
                    City: header.company_addrstate || "",
                    Pincode: header.company_addrpincode || "",
                    GSTIN: header.company_gstno || "",
                    State: header.company_addrstate || "",
                    Code: header.billto_gststatecode || "",
                    Country: header.company_addrcountry || "",
                },
                Items: Array.isArray(itemsData)
                    ? itemsData.map((item) => ({
                        quality: item.name || "",
                        gsm: item.gsm || "",
                        size: item.itemsize || "",
                        hsn: item.hsncode || "",
                        orderNo: item.invoiceorderid || "",
                        qty: item.confirmed_qty || 0,
                        uom: item.unitofmeasurecode || "",
                        totalWeight: item.confirmed_qty || 0,
                        unitPrice: item.unitprice || 0,
                        totalValue: item.itemtotalamount || 0,
                    }))
                    : [],
                TotalReels: 0,
                TotalWeight: 0,
                TotalValue: 0,
                Summary: {
                    AssessableValue: header.taxable_amount || 0,
                    TaxAmount: header.tax_amount || 0,
                    Freight: 0,
                    Insurance: 0,
                    Discount: 0,
                    NetAmount: header.net_amount || 0,
                    AmountInWords: header.netamount_inwords || "",
                    RoundOff: 0,
                },
                Transport: {
                    Name: header.transporterdetails?.match(/Transporter Name\s*:\s*(.*)/)?.[1] || "",
                    VehicleNo: header.transporterdetails?.match(/Vehicle No\.\s*:\s*(.*)/)?.[1] || "",
                    ShipmentMode: header.transporterdetails?.match(/Shipment Mode\s*:\s*(.*)/)?.[1] || "",
                    LRNo: header.transporterdetails?.match(/LR No\.\s*:\s*(.*)/)?.[1] || "",
                    TermsOfPayment: header.transporterdetails?.match(/Terms of Payment\s*:\s*(.*)/)?.[1] || "",
                    DueDate: header.transporterdetails?.match(/Due Date\s*:\s*(.*)/)?.[1] || "",
                },
                Bank: {
                    Name: header.paymentbankdetails?.match(/Name\s*:\s*(.*)/)?.[1] || "",
                    AccountNo: header.paymentbankdetails?.match(/A\/C No\s*:\s*(.*)/)?.[1] || "",
                    IFSC: header.paymentbankdetails?.match(/IFSC\s*:\s*(.*)/)?.[1] || "",
                    BankName: header.paymentbankdetails?.match(/Bank\s*:\s*(.*)/)?.[1] || "",
                    Branch: header.paymentbankdetails?.match(/Branch\s*:\s*(.*)/)?.[1] || "",
                },
                IRN: "",
                AckNo: "",
                EWayBillNumber: "",
                EWayBillDate: "",
                PlaceOfDelivery: "",
                FSC: {
                    Code: "",
                    Claim: "",
                },
            };

            // ✅ Use useState correctly — must be declared at top level, not inside try
            // setReportData(defaultReportData);


            // const f = invoiceFields;

            // base object structure
            const invoice = {
                Version: "1.1",
                TranDtls: {
                    TaxSch: "GST",
                    SupTyp: convertToBlank(headerData.SupplyType || ""),
                    IgstOnIntra: convertToBlank(headerData.IgstOnIntra || ""),
                    RegRev: convertToBlank(headerData.RegRev || ""),
                    EcmGstin: null, // not used in your code, left blank

                },
                DocDtls: {
                    Typ: "INV",
                    No: convertToBlank(headerData.SInvoiceNo || ""),
                    Dt: formatDateTo_ddMMyyyy(headerData.SInvoiceDate)
                },
                SellerDtls: {
                    Gstin: convertToBlank(defaultReportData.Seller.GSTIN || ""),
                    LglNm: convertToBlank(defaultReportData.Seller.Name || ""),
                    TrdNm: convertToBlank(defaultReportData.Seller.Name || ""),
                    Addr1: convertToBlank(defaultReportData.Seller.AddressLine1 || ""),
                    Addr2: convertToBlank(defaultReportData.Seller.AddressLine2 || ""),
                    Loc: convertToBlank(defaultReportData.Seller.State || ""),
                    Pin: toDecimal(defaultReportData.Seller.Pincode || ""),
                    Stcd: convertToBlank(defaultReportData.Seller.Code || ""),
                    Ph: convertToBlank(defaultReportData.Seller.Phonenumber || ""),
                    Em: convertToBlank(defaultReportData.Seller.Email || "")
                },
                BuyerDtls: {
                    Gstin: convertToBlank(defaultReportData.Buyer.GSTIN || ""),
                    LglNm: convertToBlank(defaultReportData.Buyer.Name || ""),
                    TrdNm: convertToBlank(defaultReportData.Buyer.Name || ""),
                    Addr1: convertToBlank(defaultReportData.Buyer.AddressLine1 || ""),
                    Addr2: convertToBlank(defaultReportData.Buyer.AddressLine2 || ""),
                    Pos: convertToBlank(defaultReportData.Buyer.Code || ""),
                    Loc: convertToBlank(defaultReportData.Buyer.State || ""),
                    Stcd: convertToBlank(defaultReportData.Buyer.Code || ""),
                    Pin: toDecimal(defaultReportData.Buyer.Pincode || ""),
                    Ph: convertToBlank(defaultReportData.Buyer.Phonenumber || ""),
                    Em: convertToBlank(defaultReportData.Buyer.Email || "")
                },
                DispDtls: null,
                ShipDtls: {
                    Gstin: convertToBlank(defaultReportData.Consignee.GSTIN || ""),
                    LglNm: convertToBlank(defaultReportData.Consignee.Name || ""),
                    TrdNm: convertToBlank(defaultReportData.Consignee.Name || ""),
                    Addr1: convertToBlank(defaultReportData.Consignee.AddressLine1 || ""),
                    Addr2: convertToBlank(defaultReportData.Consignee.AddressLine2 || ""),
                    Loc: convertToBlank(defaultReportData.Consignee.State || ""),
                    Pin: toDecimal(defaultReportData.Consignee.Pincode || ""),
                    Stcd: convertToBlank(defaultReportData.Consignee.Code || ""),
                }, // will fill below or leave null if same as bill-to
                RefDtls: {
                    InvRm: null // you commented out "NICGEPP2.0" in VB; left blank
                },
                ItemList: [],
                ValDtls: {
                    AssVal: 0,
                    CgstVal: 0,
                    SgstVal: 0,
                    IgstVal: 0,
                    CesVal: 0,
                    StCesVal: 0,
                    Discount: toDecimal(totals.totalDiscount, 0),
                    OthChrg: roundTo(convertToZero(defaultReportData.Summary.tcsAmount || 0)),
                    RndOffAmt: roundTo(convertToZero(totals.roundOff || 0)),
                    TotInvVal: roundTo(convertToZero(totals.netAmountWithRounding || 0)),
                    TotInvValFc: 0
                },
                EwbDtls: {
                    TransId: "",
                    TransName: convertToBlank(defaultReportData.Transport.Name || ""),
                    TransMode: convertToBlank(defaultReportData.Transport.ShipmentMode || ""),
                    Distance: toDecimal(headerData.Distanceinkm || 0),
                    TransDocNo: convertToBlank(defaultReportData.Transport.LRNo || ""),
                    TransDocDt: formatDateTo_ddMMyyyy(headerData.SLRDate),
                    VehNo: convertToBlank(defaultReportData.Transport.VehicleNo || ""),
                    VehType: "R"
                }
            };

            // ShipDtls mapping
            const shipGstin = convertToBlank(defaultReportData.Consignee.GSTIN || "");
            const shipObj = {
                Gstin: shipGstin,
                LglNm: convertToBlank(defaultReportData.Consignee.Name || ""),
                TrdNm: convertToBlank(defaultReportData.Consignee.Name || ""),
                Addr1: convertToBlank(defaultReportData.Consignee.AddressLine1 || ""),
                Addr2: convertToBlank(defaultReportData.Consignee.AddressLine2 || ""),
                Loc: convertToBlank(defaultReportData.Consignee.State || ""),
                Pin: toDecimal(defaultReportData.Consignee.Pincode || ""),
                Stcd: convertToBlank(defaultReportData.Consignee.Code || ""),
            };

            // If bill-to and ship-to are the same (in VB they compared SelectedValues),
            // the UI/consumer of this component should pass a flag; for now if GSTINs match, omit ShipDtls
            if (invoice.BuyerDtls.Gstin && invoice.BuyerDtls.Gstin === shipObj.Gstin) {
                invoice.ShipDtls = null;
            } else {
                invoice.ShipDtls = shipObj;
            }


            let transporterRows = [];
            await fetchAddressData(STransporter, 'Billing')
                .then(data => {
                    transporterRows = data;
                })
                .catch(error => {
                    showError('Unable to get the address properly.!', 'error');
                });

            // If transporter TransId (row 7 col 1) is 15-length then set TransId
            const tci = transporterRows[6].LabelValueColumn2
            if (String(tci).length === 15) invoice.EwbDtls.TransId = convertToBlank(tci);

            // Build ItemList from productItems
            const itemList = [];
            let lineSno = 0;
            if (Array.isArray(rowsConfirmedOrdersDespacth)) {
                for (const PItem of rowsConfirmedOrdersDespacth) {
                    lineSno += 1;
                    const PrdDesc = `${PItem.SIVariety || ""} - ${PItem.SIGSM || ""} GSM`.trim();
                    const qty = roundTo(toDecimal(PItem.SIShipped_Qty || 0), 3);
                    const assAmt = toDecimal(PItem.SILineTaxableAmount || 0);
                    const unitPrice = qty !== 0 ? roundTo(assAmt / qty, 2) : toDecimal(PItem.SIUnitPrice || 0);

                    const gstRt = toDecimal(PItem.SICGSTPercent || 0) + toDecimal(PItem.SISGSTPercent || 0);
                    const igstAmt = toDecimal(PItem.SIIGSTAmount || 0);
                    const cgstAmt = toDecimal(PItem.SICGSTAmount || 0);
                    const sgstAmt = toDecimal(PItem.SISGSTAmount || 0);

                    const newItem = {
                        SlNo: String(lineSno),
                        PrdDesc,
                        IsServc: "N",
                        HsnCd: convertToBlank(PItem.SIHSNCode || ""),
                        Qty: qty,
                        FreeQty: 0,
                        Unit: (PItem.SIUnit ? `${PItem.SIUnit}S` : "UNIT"),
                        UnitPrice: unitPrice,
                        TotAmt: roundTo(toDecimal(PItem.SILineTaxableAmount || 0) - toDecimal(PItem.SIDiscountAmount || 0), 2),
                        Discount: roundTo(toDecimal(PItem.SIDiscountAmount || 0), 2),
                        PreTaxVal: 0,
                        AssAmt: assAmt,
                        GstRt: gstRt,
                        IgstAmt: igstAmt,
                        CgstAmt: cgstAmt,
                        SgstAmt: sgstAmt,
                        CesRt: 0,
                        CesAmt: 0,
                        CesNonAdvlAmt: 0,
                        StateCesRt: 0,
                        StateCesAmt: 0,
                        StateCesNonAdvlAmt: 0,
                        OthChrg: 0,
                        TotItemVal: roundTo(toDecimal(PItem.SILineTaxAmount || 0), 2)
                    };

                    itemList.push(newItem);
                }
            }

            // Add Freight as a separate line if > 0 (rebuilt from VB logic)
            const freightAmtRaw = toDecimal(defaultReportData.Summary.Freight || 0);
            let freightWithInsurance = freightAmtRaw;
            const insuranceRate = toDecimal(defaultReportData.Summary.Insurance || 0);
            if (insuranceRate !== 0 && freightAmtRaw !== 0) {
                freightWithInsurance = freightAmtRaw + roundTo((freightAmtRaw * (insuranceRate / 100)), 2);
            }

            if (freightWithInsurance > 0) {
                lineSno += 1;
                // In VB they reused itemList[0].GstRt to determine tax split; if items exist use that
                const baseGST = itemList.length > 0 ? itemList[0].GstRt : 0;
                const igstPresent = itemList.length > 0 ? (itemList[0].IgstAmt > 0) : false;

                const igstAmount = igstPresent ? roundTo((freightWithInsurance * (baseGST / 100)), 2) : 0;
                const cgstAmount = !igstPresent ? roundTo((freightWithInsurance * (baseGST / 200)), 2) : 0;
                const sgstAmount = !igstPresent ? roundTo((freightWithInsurance * (baseGST / 200)), 2) : 0;

                const freightItem = {
                    SlNo: String(lineSno),
                    PrdDesc: "Freight on Sales",
                    IsServc: "Y",
                    HsnCd: "996532",
                    Qty: 0,
                    FreeQty: 0,
                    Unit: "OTH",
                    UnitPrice: 0,
                    TotAmt: roundTo(freightWithInsurance, 2),
                    Discount: 0,
                    PreTaxVal: 0,
                    AssAmt: roundTo(freightWithInsurance, 2),
                    GstRt: baseGST,
                    IgstAmt: igstAmount,
                    CgstAmt: cgstAmount,
                    SgstAmt: sgstAmount,
                    CesRt: 0,
                    CesAmt: 0,
                    CesNonAdvlAmt: 0,
                    StateCesRt: 0,
                    StateCesAmt: 0,
                    StateCesNonAdvlAmt: 0,
                    OthChrg: 0,
                    TotItemVal: roundTo(roundTo(freightWithInsurance, 2) + igstAmount + cgstAmount + sgstAmount, 2)
                };

                itemList.push(freightItem);
            }

            invoice.ItemList = itemList;

            // ValDtls: compute totals similar to VB
            const OverallTaxableAmount = itemList.reduce((acc, it) => acc + toDecimal(it.AssAmt || 0), 0);
            invoice.ValDtls.AssVal = roundTo(OverallTaxableAmount, 2);

            // VB uses itemList(0).IgstAmt to decide whether IGST or CGST+SGST applies for all
            if (itemList.length > 0 && itemList[0].IgstAmt > 0) {
                invoice.ValDtls.IgstVal = roundTo(OverallTaxableAmount * (itemList[0].GstRt / 100), 2);
                invoice.ValDtls.CgstVal = 0.0;
                invoice.ValDtls.SgstVal = 0.0;
            } else if (itemList.length > 0) {
                invoice.ValDtls.IgstVal = 0.0;
                invoice.ValDtls.CgstVal = roundTo(OverallTaxableAmount * (itemList[0].GstRt / 200), 2);
                invoice.ValDtls.SgstVal = roundTo(OverallTaxableAmount * (itemList[0].GstRt / 200), 2);
            } else {
                invoice.ValDtls.IgstVal = 0.0;
                invoice.ValDtls.CgstVal = 0.0;
                invoice.ValDtls.SgstVal = 0.0;
            }

            // Oth fields already set (Discount, OthChrg, RndOffAmt, TotInvVal)
            return invoice;



        } catch (error) {
            console.error('Error loading invoice details:', error);
            showError('Failed to load invoice details.', 'error');
        }

    }

    async function saveInvoiceAsJson() {
        try {
            // Wait for the invoice object to be fully built
            const invoiceObject = await buildInvoiceObject();
            const jsonStr = JSON.stringify(invoiceObject, null, 2); // pretty print
            const filename = `${IParentInvoiceOrder_ID || "invoice"}.json`;

            // trigger download (no external library)
            const blob = new Blob([jsonStr], { type: "application/json;charset=utf-8" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // IE fallback
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }

            alert("Invoice file download completed successfully.");
        } catch (err) {
            console.error(err);
            alert("Unable to generate JSON data for the invoice.");
        }
    }


    // on change frieght amount
    const onChangeFreightPerMt = (freightPerMt) => {
        setManualFreightRate(freightPerMt);

        const updatedHeaderData = {
            ...headerData,
            FreightPerMT: freightPerMt,
        };

        setHeaderData(updatedHeaderData);

        // ✅ Now call with the latest data
        handleOrderItemCalculation(updatedHeaderData, rowsConfirmedOrdersDespacth);
    };


    const onChangeServiceCharge = (serviceCharge) => {
        setManualServiceChargeRate(serviceCharge);

        const updatedHeaderData = {
            ...headerData,
            ServiceChargeRate: serviceCharge,
        };

        setHeaderData(updatedHeaderData);

        // ✅ Now call with the latest data
        handleOrderItemCalculation(updatedHeaderData, rowsConfirmedOrdersDespacth);
    };


    const onChangeCessRate = (cessRate) => {
        setManualCessRate(cessRate);

        const updatedHeaderData = {
            ...headerData,
            CessRate: cessRate,
        };

        setHeaderData(updatedHeaderData);

        // ✅ Now call with the latest data
        handleOrderItemCalculation(updatedHeaderData, rowsConfirmedOrdersDespacth);
    };

    const onChangeTcsRate = (TcsRate) => {
        setManualTCSRate(TcsRate);

        const updatedHeaderData = {
            ...headerData,
            Tcsrate: TcsRate,
        };

        setHeaderData(updatedHeaderData);

        // ✅ Now call with the latest data
        handleOrderItemCalculation(updatedHeaderData, rowsConfirmedOrdersDespacth);
    };


    const onChangInsuranceCharge = (insuranceRate) => {
        setManualInsuranceRate(insuranceRate);

        const updatedHeaderData = {
            ...headerData,
            insuranceRatePct: insuranceRate,
        };

        setHeaderData(updatedHeaderData);

        // ✅ Now call with the latest data
        handleOrderItemCalculation(updatedHeaderData, rowsConfirmedOrdersDespacth);
    };


    const onRowValueChange = async (updatedRows) => {
        await handleOrderItemCalculation(headerData, updatedRows);
    }

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData_orders.length / recordsPerPage);

    const uniqueValues = {
        InvoiceStatus: [...new Set(rowsConfirmedOrders.map(row => row.InvoiceStatus))],
        BillToCustomer: [...new Set(rowsConfirmedOrders.map(row => row.BillToCustomer))],
        ShipToCustomer: [...new Set(rowsConfirmedOrders.map(row => row.ShipToCustomer))],
        ShipToCity: [...new Set(rowsConfirmedOrders.map(row => row.ShipToCity))],
        ShipToState: [...new Set(rowsConfirmedOrders.map(row => row.ShipToState))],
        ConfirmationNo: [...new Set(rowsConfirmedOrders.map(row => row.ConfirmationNo))],
        PartyPONo: [...new Set(rowsConfirmedOrders.map(row => row.PartyPONo))],
        ShippedOrderNo: [...new Set(rowsConfirmedOrders.map(row => row.ShippedOrderNo))],
        PaymentTerm: [...new Set(rowsConfirmedOrders.map(row => row.PaymentTerm))],
        TruckNumber: [...new Set(rowsConfirmedOrders.map(row => row.TruckNumber))],
    };


    // Get the records for the current page
    const currentRecords = filteredData_orders.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const columns = ['', 'InvoiceStatus', 'BillToCustomer', 'Email', 'ShipToCustomer', 'ShipToCity', 'ShipToState', 'ConfirmationNo', 'ConfirmationDate', 'PartyPONo', 'ShippedOrderNo', 'ShippedOrderDate', 'PaymentTerm', 'TruckNumber',];

    const autoCompleteColumns = ['InvoiceStatus', 'BillToCustomer', 'ShipToCustomer', 'ShipToCity', 'ShipToState', 'ConfirmationNo', 'PartyPONo', 'ShippedOrderNo', 'PaymentTerm', 'TruckNumber',];



    return (
        < >

            {viewInvoiceDetail && (<>

                {viewCreateDespatchPlan && (

                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirstOrder}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}
                            >
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('All Delivery Order')}>All Delivery Order</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('New')}>New</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Approved')}>Approved</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Cancelled')}>Cancelled</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Under Amendment')}>Under Amendment</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Processed')}>Processed</MenuItem>
                            </Menu>

                            {/* Spacer to push buttons to the right */}
                            <Box sx={{ flexGrow: 1 }} />

                            <div>
                                {/* <Tooltip title="View Invoice Report">
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleShowReport}
                                        startIcon={<AddIcon />}
                                        sx={{ textTransform: "none", marginLeft: 2, }}
                                    >
                                        View Invoice Report
                                    </Button>
                                </Tooltip> */}

                                <Dialog
                                    open={showInvoiceReport}
                                    onClose={handleCloseReport}
                                    maxWidth={false}
                                    fullWidth={false}
                                    PaperProps={{
                                        sx: {
                                            width: "794px",        // A4 width
                                            height: "1123px",      // A4 height
                                            margin: "auto",
                                            backgroundColor: "#fff",
                                        },
                                    }}
                                >
                                    <DialogTitle
                                        sx={{
                                            backgroundColor: "#fff",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        Invoice Report
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleCloseReport}
                                            sx={{
                                                position: "absolute",
                                                right: 8,
                                                top: 8,
                                                color: "#000",
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </DialogTitle>

                                    <DialogContent sx={{ p: 0, backgroundColor: "#fff" }}>
                                        <InvoiceReport onClose={handleCloseReport} />
                                    </DialogContent>
                                </Dialog>

                                {showInvoiceReport && (
                                    <InvoiceReport onClose={handleCloseReport} />
                                )}
                            </div>

                            <Tooltip title="Create New Invoice" >
                                {isVisiblebtnCreateDespatchPlan && (
                                    <Button size="small" variant="contained" onClick={handleShowDispatchPlansEntry} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 2, textTransform: 'none' }}>New</Button>
                                )}
                            </Tooltip>


                            {/* Second Menu */}
                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Items" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Items" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>

                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ mr: 1, ml: 1 }}
                                onClick={handleMenuClickSecond}
                            >
                                <HelpIcon />
                            </IconButton>

                            <div>
                                <IconButton>
                                    <Close fontSize="inherit" onClick={handleBackWinderMachineEntry} style={{ color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>

                )}


                {viewCreateDespatchPlan && (
                    <form onSubmit={handleSubmitConfirmationOrder}>
                        <Box>
                            <Grid container spacing={0}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <DateRangePickerForInvoice
                                        fromDate={FromCODate}
                                        toDate={ToCODate}
                                        onFromChange={(date) => handleFromCODate(date, "from")}
                                        onToChange={(date) => handleToCODate(date, "to")}
                                        autoFocus
                                        searchType={searchType}
                                        searchValue={searchValue}
                                        onSearchTypeChange={(e) => setSearchType(e.target.value)}
                                        onSearchValueChange={(e) => setSearchValue(e.target.value)}
                                        onSearchClick={handleSubmitConfirmationOrder}
                                        showSamePartyToggle={true}    // 🔥 show toggle on this page
                                        sameParty={sameParty}
                                        setSameParty={setSameParty}
                                    />


                                    <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '85vh', xl: '100vh' }}>
                                        <CustomTableContainer colors={colors}>
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead sx={{ height: 30, backgroundColor: colors.primary[400] }}>
                                                        <TableRow>
                                                            <TableCell>
                                                                {/* <Checkbox
                                                                size="small"
                                                                color="secondary"
                                                                indeterminate={selectedRows_orders.length > 0 && selectedRows_orders.length < rowsConfirmedOrders.length}
                                                                checked={selectedRows_orders.length === rowsConfirmedOrders.length}
                                                                onChange={handleSelectAllClick}
                                                            /> */}
                                                                Select
                                                            </TableCell>
                                                            <TableCell>Invoice Status</TableCell>
                                                            <TableCell>Bill-To Party</TableCell>
                                                            <TableCell>Email</TableCell>
                                                            <TableCell>Ship-To Party</TableCell>
                                                            <TableCell>Ship To City</TableCell>
                                                            <TableCell>Ship To State</TableCell>
                                                            <TableCell>CO No</TableCell>
                                                            <TableCell>CO Date</TableCell>
                                                            <TableCell>PO No</TableCell>

                                                            <TableCell>DO No</TableCell>
                                                            <TableCell>DO Date</TableCell>
                                                            <TableCell>Payment Term</TableCell>
                                                            <TableCell>Truck Number</TableCell>

                                                        </TableRow>

                                                        <TableFilterRow
                                                            columns={columns}
                                                            filters={filters}
                                                            handleFilterChange={handleFilterChange}
                                                            uniqueValues={uniqueValues}
                                                            autoCompleteColumns={autoCompleteColumns}
                                                        />
                                                    </TableHead>
                                                    <TableBody>
                                                        {currentRecords.map((row, index) => (
                                                            <TableRow key={row.id} selected={isSelected1_order(row.id)}
                                                                sx={{
                                                                    backgroundColor:
                                                                        index % 2 === 0
                                                                            ? theme.palette.background.default
                                                                            : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                                                }}>
                                                                <TableCell>
                                                                    <Checkbox
                                                                        size="small"

                                                                        checked={isSelected1_order(row.id)}
                                                                        onChange={(event) => handleRowCheckboxClickDeliveryOrder(event, row.id)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{row.InvoiceStatus}</TableCell>
                                                                <TableCell>{row.BillToCustomer}</TableCell>
                                                                <TableCell>{row.Email}</TableCell>
                                                                <TableCell>{row.ShipToCustomer}</TableCell>
                                                                <TableCell>{row.ShipToCity}</TableCell>
                                                                <TableCell>{row.ShipToState}</TableCell>
                                                                <TableCell>{row.ConfirmationNo}</TableCell>
                                                                <TableCell>
                                                                    {row.ConfirmationDate
                                                                        ? dayjs(row.ConfirmationDate).format("DD-MMM-YYYY")
                                                                        : ""}
                                                                </TableCell>

                                                                <TableCell>{row.PartyPONo}</TableCell>
                                                                <TableCell>{row.ShippedOrderNo}</TableCell>


                                                                <TableCell>
                                                                    {row.ShippedOrderDate
                                                                        ? dayjs(row.ShippedOrderDate).format("DD-MMM-YYYY")
                                                                        : ""}
                                                                </TableCell>


                                                                <TableCell>{row.PaymentTerm}</TableCell>
                                                                <TableCell>{row.TruckNumber}</TableCell>


                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </CustomTableContainer>
                                    </ResponsiveBox>

                                    <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                )}



                <CustomSnackbar open={snackbarOpen} message={alertMessage} onClose={handleSnackbarClose} type={alertsevierity} />

                <InvoiceActionMenu
                    isVisible={viewCommonButton}
                    fromModule={fromModule}
                    headerText={headerDespatchplan}

                    btnSaveUpdate={btnSaveUpdate}
                    btnCancel={btnCancel}
                    btnApprove={btnApprove}
                    btnAmendment={btnAmendment}
                    btnPrint={btnPrint}
                    btnGenerateInvoice={btnGenerateInvoice}

                    btnSaveText="Save Invoice"
                    btnSaveTooltip="Save or Update Invoice"

                    handleBack={handleBackTofromDespacthPlanEntry}
                    handleSave={() => handleSaveInvoiceOrder(true)}
                    handleCancel={handleCancel}
                    handleApprove={handleApproveAndAmendInvoice}
                    handleAmend={handleApproveAndAmendInvoice}
                    handlePrint={handleViewReport}
                    handleGenerateInvoice={handleGenerateInvoiceOrder}
                />

                {viewCommonButton && (
                    <Divider style={{ marginBottom: "1px" }} />
                )}

                {viewCreateInvoiceEntry && (
                    <InvoiceEntryTemplate
                        colors={colors}
                        theme={theme}
                        IParentInvoiceOrder_ID={IParentInvoiceOrder_ID}
                        SInvoiceNo={SInvoiceNo}
                        selectedCustomer={selectedCustomer}
                        dataCustomer={dataCustomer}
                        handleSelectCustomer={handleSelectCustomer}
                        customerAddress={customerAddress}
                        OrderDate={OrderDate}
                        minInvoiceDate={minInvoiceDate}
                        handlerOrderDate={handlerOrderDate}
                        selectedSupplier={selectedSupplier}
                        dataSupplier={dataSupplier}
                        handleSelectSupplier={handleSelectSupplier}
                        supplierAddress={supplierAddress}
                        SRefNo={SRefNo}
                        handleSelectPoNo={handleSelectPoNo}
                        selectedTransporter={selectedTransporter}
                        dataTransporter={dataTransporter}
                        handleSelectTransporter={handleSelectTransporter}
                        ScheduleDate={ScheduleDate}
                        handleScheduleDate={handleScheduleDate}
                        selectedPricelist={selectedPricelist}
                        dataPricelist={dataPricelist}
                        handleSelectPricelist={handleSelectPricelist}
                        Remarks={Remarks}
                        SetRemarks={SetRemarks}
                        visibleAmendmentReason={visibleAmendmentReason}
                        SAmendmentReason={SAmendmentReason}
                        handleSelectAmendmentReason={handleSelectAmendmentReason}
                        amendmentReasonFoucs={amendmentReasonFoucs}
                        viewCancelDetail={viewCancelDetail}
                        Reason={Reason}
                        handleEnterReason={handleEnterReason}
                        ReasonError={ReasonError}
                        cancelDate={cancelDate}
                        handleDateChange={handleDateChange}
                        DateError={DateError}
                        rowsConfirmedOrdersDespacth={rowsConfirmedOrdersDespacth}
                        // columnsConfirmedOrdersDespacth={columnsConfirmedOrdersDespacth}
                        rowModesModel={rowModesModel}
                        handleRowModesModelChange={handleRowModesModelChange}
                        handleRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        setrowsConfirmedOrdersDespacth={setrowsConfirmedOrdersDespacth}
                        setRowModesModel={setRowModesModel}
                        EditToolbar={EditToolbar}
                        totalSIConfirmedQty={totalSIConfirmedQty}
                        totalGrossAmount={totalGrossAmount}
                        totaldiscountAmount={totaldiscountAmount}
                        totalAmount={totalAmount}
                        billToCustomerError={billToCustomerError}
                        shipToCustomerError={shipToCustomerError}
                        transporterError={transporterError}
                        priceListError={priceListError}
                        amendReasonError={amendReasonError}
                        selectedShipmentMode={selectedShipmentMode}
                        handleSelectShipmentMode={handleSelectShipmentMode}
                        dataShipmentmode={dataShipmentmode}
                        selectedPaymentTerm={selectedPaymentTerm}
                        handleSelectPaymentTerm={handleSelectPaymentTerm}
                        dataPaymentterm={dataPaymentterm}

                        selectedCreditTerm={selectedCreditTerm}
                        handleSelectCreditTerm={handleSelectCreditTerm}
                        dataCreditterm={dataCreditterm}
                        selectedCreditTermRule={selectedCreditTermRule}
                        handleSelectCreditTermRule={handleSelectCreditTermRule}
                        dataCredittermRule={dataCredittermRule}
                        cancelReasonFoucs={cancelReasonFoucs}

                        truckNumber={truckNumber}
                        lrNumber={lrNumber}
                        lrDate={lrDate}
                        distance={distance}
                        setDistance={setDistance}
                        headerData={headerData}
                        defaultParameterConfig={defaultParameterConfig}
                        totals={totals}
                        handleSaveJsonFile={saveInvoiceAsJson}
                        manualTCSRate={manualTCSRate}
                        setManualTCSRate={setManualTCSRate}
                        manualFreightRate={manualFreightRate}
                        setManualFreightRate={setManualFreightRate}
                        manualServiceChargeRate={manualServiceChargeRate}
                        setManualServiceChargeRate={setManualServiceChargeRate}
                        manualCessRate={manualCessRate}
                        setManualCessRate={setManualCessRate}
                        manualInsuranceRate={manualInsuranceRate}
                        setManualInsuranceRate={setManualInsuranceRate}
                        onChangeFreightPerMt={onChangeFreightPerMt}
                        onChangeServiceCharge={onChangeServiceCharge}
                        onChangeCessRate={onChangeCessRate}
                        onChangeTcsRate={onChangeTcsRate}
                        onChangInsuranceCharge={onChangInsuranceCharge}
                        manualTCSRateEdit={manualTCSRateEdit}
                        onRowValueChange={onRowValueChange}
                    />
                )}

            </>)}

            {viewPackingList && (<> <PackingListReport apiData={PackingList} callback={handlePackinglistcallback} /> </>)}
            {viewInvoiceReport && (<> <InvoiceReport apiData={InvoiceList} callback={handleInvoicelistcallback} orderItems={rowsConfirmedOrdersDespacth} totals={totals} /> </>)}

        </>





    );
};

export default CreateNewInvoice;